// The PR for this original change is here: https://microsoft.visualstudio.com/Universal%20Store/_git/MSEG.EAE.ServiceDesk.SDK/pullrequest/329117?_a=commits
// Additional change revising top PR: https://microsoft.visualstudio.com/Universal%20Store/_git/MSEG.EAE.ServiceDesk.SDK/pullrequest/346145?_a=overvi
// Version 4.2.9 from https://microsoft.visualstudio.com/DefaultCollection/Universal%20Store/_packaging?feedName=CommonSchema&protocolType=NuGet&packageName=jsllscripts&packageVersion=4.2.9&_a=view
// -----------------------------------------------------------------------
//  <copyright file="objectDefinition.ts" company="Microsoft">
//      Copyright (c) Microsoft. All rights reserved.
//  </copyright>
//  <summary>
//      This module handles the definition of the Asimov object
//  </summary>
// -----------------------------------------------------------------------
/* tslint:disable:comment-format-lower-case */
/* tslint:enable */
var awa = awa || {};
awa.isInitialized = false;
// -----------------------------------------------------------------------
//  <copyright file="enums.ts" company="Microsoft">
//      Copyright (c) Microsoft. All rights reserved.
//  </copyright>
//  <summary>
//      This module defines global awa.* enums.
//  </summary>
// -----------------------------------------------------------------------
// Define available console verbosity levels and set default
awa.verbosityLevels = {
  NONE: 0,
  ERROR: 1,
  WARNING: 2,
  INFORMATION: 3
};
// Behavior enum values
awa.behavior = {
  UNDEFINED: 0,
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  // Page Experience [1-19]
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  NAVIGATIONBACK: 1,
  NAVIGATION: 2,
  NAVIGATIONFORWARD: 3,
  APPLY: 4,
  REMOVE: 5,
  SORT: 6,
  EXPAND: 7,
  REDUCE: 8,
  CONTEXTMENU: 9,
  TAB: 10,
  COPY: 11,
  EXPERIMENTATION: 12,
  PRINT: 13,
  SHOW: 14,
  HIDE: 15,
  MAXIMIZE: 16,
  MINIMIZE: 17,
  BACKBUTTON: 18,
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  // Scenario Process [20-39]
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  STARTPROCESS: 20,
  PROCESSCHECKPOINT: 21,
  COMPLETEPROCESS: 22,
  SCENARIOCANCEL: 23,
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  // Download [40-59]
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  DOWNLOADCOMMIT: 40,
  DOWNLOAD: 41,
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  // Search [60-79]
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  SEARCHAUTOCOMPLETE: 60,
  SEARCH: 61,
  SEARCHINITIATE: 62,
  TEXTBOXINPUT: 63,
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  // Commerce [80-99]
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  PURCHASE: 80,
  ADDTOCART: 81,
  VIEWCART: 82,
  ADDWISHLIST: 83,
  FINDSTORE: 84,
  CHECKOUT: 85,
  REMOVEFROMCART: 86,
  PURCHASECOMPLETE: 87,
  VIEWCHECKOUTPAGE: 88,
  VIEWCARTPAGE: 89,
  VIEWPDP: 90,
  UPDATEITEMQUANTITY: 91,
  INTENTTOBUY: 92,
  PUSHTOINSTALL: 93,
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  // Authentication [100-119]
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  SIGNIN: 100,
  SIGNOUT: 101,
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  // Social [120-139]
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  SOCIALSHARE: 120,
  SOCIALLIKE: 121,
  SOCIALREPLY: 122,
  CALL: 123,
  EMAIL: 124,
  COMMUNITY: 125,
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  // Feedback [140-159]
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  VOTE: 140,
  SURVEYINITIATE: 141,
  SURVEYCOMPLETE: 142,
  REPORTAPPLICATION: 143,
  REPORTREVIEW: 144,
  SURVEYCHECKPOINT: 145,
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  // Registration, Contact [160-179]
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  CONTACT: 160,
  REGISTRATIONINITIATE: 161,
  REGISTRATIONCOMPLETE: 162,
  CANCELSUBSCRIPTION: 163,
  RENEWSUBSCRIPTION: 164,
  CHANGESUBSCRIPTION: 165,
  REGISTRATIONCHECKPOINT: 166,
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  // Chat [180-199]
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  CHATINITIATE: 180,
  CHATEND: 181,
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  // Trial [200-219]
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  TRIALSIGNUP: 200,
  TRIALINITIATE: 201,
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  // Parner Referal [220-239]
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  PARTNERREFERRAL: 220,
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  // Video [240-259]
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  VIDEOSTART: 240,
  VIDEOPAUSE: 241,
  VIDEOCONTINUE: 242,
  VIDEOCHECKPOINT: 243,
  VIDEOJUMP: 244,
  VIDEOCOMPLETE: 245,
  VIDEOBUFFERING: 246,
  VIDEOERROR: 247,
  VIDEOMUTE: 248,
  VIDEOUNMUTE: 249,
  VIDEOFULLSCREEN: 250,
  VIDEOUNFULLSCREEN: 251,
  VIDEOREPLAY: 252,
  VIDEOPLAYERLOAD: 253,
  VIDEOPLAYERCLICK: 254,
  VIDEOVOLUMECONTROL: 255,
  VIDEOAUDIOTRACKCONTROL: 256,
  VIDEOCLOSEDCAPTIONCONTROL: 257,
  VIDEOCLOSEDCAPTIONSTYLE: 258,
  VIDEORESOLUTIONCONTROL: 259,
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  // Virtual Event [260-279]
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  VIRTUALEVENTJOIN: 260,
  VIRTUALEVENTEND: 261,
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  // 	Advertisement Engagement [280-299]
  ///////////////////////////////////////////////////////////////////////////////////////////////////
  IMPRESSION: 280,
  CLICK: 281,
  RICHMEDIACOMPLETE: 282,
  ADBUFFERING: 283,
  ADERROR: 284,
  ADSTART: 285,
  ADCOMPLETE: 286,
  ADSKIP: 287,
  ADTIMEOUT: 288,
  OTHER: 300 // Other
};
// extract keys for validation
awa.behaviorKeys = [];
for (var behaviorKey in awa.behavior) {
  awa.behaviorKeys.push(behaviorKey);
}
awa.actionType = {
  CLICKLEFT: "CL",
  CLICKRIGHT: "CR",
  CLICKMIDDLE: "CM",
  SCROLL: "S",
  ZOOM: "Z",
  RESIZE: "R",
  KEYBOARDENTER: "KE",
  KEYBOARDSPACE: "KS",
  OTHER: "O"
};
// -----------------------------------------------------------------------
//  <copyright file="cookie.ts" company="Microsoft">
//      Copyright (c) Microsoft. All rights reserved.
//  </copyright>
//  <summary>
//      This module contains the generic cookie utilities.
//  </summary>
// -----------------------------------------------------------------------
awa.cookie = (function () {
  function getCookieKeyValue(cookieName, keyName) {
    var cookie = getCookie(cookieName);
    if (cookie && keyName) {
      for (var u = cookie.split("&"), r = 0; r < u.length; r++) {
        var keyvalue = u[r].split("=");
        if (keyvalue[0] && keyName.toLowerCase() === keyvalue[0].toLowerCase()) {
          return keyvalue[1];
        }
      }
    }
    return undefined;
  }
  function getCookie(name, valuePrefix) {
    var allcookies = document.cookie.split(";");
    for (var i = 0; i < allcookies.length; i++) {
      var cookie = allcookies[i];
      while (cookie.charAt(0) === " ") {
        cookie = cookie.substring(1);
      }
      var parts = cookie.split("=");
      var cookieName = decode(parts.shift());
      if (cookieName === name && parts[0].indexOf(valuePrefix) == (awa.utils.isValueAssigned(valuePrefix) ? 0 : -1)) {
        return decode(parts.join("="));
      }
    }
    return undefined;
  }
  function getAllCookies() {
    var allCookiesArray = document.cookie.split(";");
    var allCookiesObject = {};
    for (var i = 0; i < allCookiesArray.length; i++) {
      var cookie = allCookiesArray[i];
      while (cookie.charAt(0) === " ") {
        cookie = cookie.substring(1);
      }
      var parts = cookie.split("=");
      var cookieName = decode(parts.shift());
      // WEBI sets an MSFPC with a different format - we do not care for it
      if (
        cookieName != "MSFPC" ||
        (cookieName === "MSFPC" && parts[0].indexOf("GUID") == (awa.utils.isValueAssigned("GUID") ? 0 : -1))
      ) {
        allCookiesObject[cookieName] = decode(parts.join("="));
      }
    }
    return allCookiesObject;
  }
  function decode(inputString) {
    var value = decodeURIComponent(inputString.replace("/+/g", " ")); // ignore jslint
    // unRfc2068
    if (value.indexOf('"') === 0) {
      // This is a quoted cookie as according to RFC2068, unescape
      value = value.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\");
    }
    return value;
  }
  function setCookie(name, value, days) {
    var expires;
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    } else {
      expires = "";
    }
    window.document.cookie = name + "=" + value + expires + "; path=/;";
  }
  function deleteCookie(name) {
    setCookie(name, "", -1);
  }
  return {
    getCookie: getCookie,
    getCookieKeyValue: getCookieKeyValue,
    getAllCookies: getAllCookies,
    setCookie: setCookie,
    deleteCookie: deleteCookie
  };
})();
// -----------------------------------------------------------------------
//  <copyright file="CorrelationVector.ts" company="Microsoft">
//      Copyright (c) Microsoft. All rights reserved.
//  </copyright>
//  <summary>
//      This module handles all the correlation vector data.
//  </summary>
// -----------------------------------------------------------------------
awa.cv = (function () {
  var UNINITIALIZED_CV = "";
  var base = UNINITIALIZED_CV;
  var currentElement = 0;
  var eventTag = "cV";
  var header = "MS-CV";
  var base64CharSet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  // cv version-dependent constants
  var cv1Constants = {};
  cv1Constants.maxCorrelationVectorLength = 63;
  cv1Constants.baseLength = 16;
  cv1Constants.validationPattern = new RegExp(
    "^[" + base64CharSet + "]{" + cv1Constants.baseLength.toString() + "}(.[0-9]+)+$"
  );
  var cv2Constants = {};
  cv2Constants.maxCorrelationVectorLength = 127;
  cv2Constants.baseLength = 22;
  cv2Constants.validationPattern = new RegExp(
    "^[" + base64CharSet + "]{" + cv2Constants.baseLength.toString() + "}(.[0-9]+)+$"
  );
  var currentCvConstants = cv2Constants;
  var cvVersionAtLatestValidityCheck = 2;
  function isInit() {
    return isValid(storedCv());
  }
  function storedCv() {
    /// <summary> creates the cv element from stored variables </summary>
    /// <returns> cV element in string format </returns>
    return base.concat(".", currentElement.toString());
  }
  function getValue() {
    /// <summary>
    /// Privileged method to serialize the current value of the Correlation Vector.
    /// CV should not be read from meta tag, but this is a breaking change.
    /// </summary>
    /// <returns type="string">Serialized value of the Correlation Vector</returns>
    var value = storedCv();
    if (isValid(value)) {
      return value;
    }
  }
  function incrementExternal(externalCv) {
    /// <summary> this method verifies and increments external cVs </summary>
    /// <param name="externalCv" type="string"> the cv to be incremented </param>
    /// <returns type="string"> the incremented cv if the incrementation was succesful </returns>
    if (isValid(externalCv)) {
      // decompose external cV
      var externalCvParts = externalCv.split(".");
      var numberOfCvParts = externalCvParts.length;
      // increment last part of cV
      externalCvParts[numberOfCvParts - 1] = (parseInt(externalCvParts[numberOfCvParts - 1], 10) + 1).toString();
      // recombine cV
      var incrementedCv = "";
      for (var i = 0; i < numberOfCvParts; i++) {
        incrementedCv += externalCvParts[i];
        if (i < numberOfCvParts - 1) {
          incrementedCv += ".";
        }
      }
      // to support cv 1 & 2
      var maxLength =
        externalCvParts[0].length === cv2Constants.baseLength
          ? cv2Constants.maxCorrelationVectorLength
          : cv1Constants.maxCorrelationVectorLength;
      if (incrementedCv.length <= maxLength) {
        return incrementedCv;
      }
    }
  }
  function canExtend() {
    /// <summary>
    /// Private method to check if the Correlation Vector can be extended
    /// </summary>
    /// <param name="ref" type="reference">Object reference to the Correlation Vector</param>
    /// <returns type="boolean">True if the Correlation Vector can be extended, false otherwise.</returns>
    var currentCv = storedCv();
    if (isValid(currentCv)) {
      return isLeqThanMaxCorrelationVectorLength(currentCv.length + 2);
    }
    return false;
  }
  function canIncrement() {
    /// <summary>
    /// Private method to check if the Correlation Vector can be incremented
    /// </summary>
    /// <returns type="boolean">True if the Correlation Vector can be incremented, false otherwise.</returns>
    if (isValid(storedCv())) {
      return isLeqThanMaxCorrelationVectorLength(base.length + 1 + (currentElement + 1 + "").length);
    }
    return false;
  }
  function setValue(cv) {
    /// <summary>
    /// Privileged method to de-serialize and set the current value of the Correlation Vector
    /// from a serialized CV string
    /// There is a breaking change in this code - setValue should not return the correlation
    /// vector. True or false is the agreed upon way, but later.
    /// </summary>
    /// <returns type="string">Serialized value of the updated Correlation Vector</returns>
    if (isValid(cv)) {
      var lastIndex = cv.lastIndexOf(".");
      base = cv.substr(0, lastIndex);
      currentElement = parseInt(cv.substr(lastIndex + 1), 10);
    } else {
      awa.logger.logWarning("Cannot set invalid correlation vector value");
      return null;
    }
    return storedCv();
  }
  function init(cvInitValue) {
    /// <summary>
    /// This function should always be called by adopters, and never be called by JSLL
    /// </summary>
    /// <param type = "string"> optional cv constructor value </param>
    /// <returns type="string">Serialized Correlation Vector</returns>
    if (cvInitValue) {
      return setValue(cvInitValue);
    } else {
      base = seedCorrelationVector();
      currentElement = 0;
      return getValue();
    }
  }
  function seedCorrelationVector() {
    /// <summary>
    /// Seed function to randomly generate a 16 character base64 encoded string for the Correlation Vector's base value
    /// </summary>
    /// <returns type="string">Returns generated base value</returns>
    var result = "";
    for (var i = 0; i < currentCvConstants.baseLength; i++) {
      result += base64CharSet.charAt(Math.floor(Math.random() * base64CharSet.length));
    }
    return result;
  }
  function extend() {
    /// <summary>
    /// Privileged method to extend the current value of the Correlation Vector
    /// </summary>
    /// <returns type="string">Serialized value of the extended Correlation Vector</returns>
    if (canExtend()) {
      base = base.concat(".", currentElement.toString());
      currentElement = 0;
      return storedCv();
    }
  }
  function increment() {
    /// <summary>
    /// Privileged method to increment the current value of the Correlation Vector
    /// </summary>
    /// <returns type="string">Serialized value of the incremented Correlation Vector</returns>
    if (canIncrement()) {
      currentElement = currentElement + 1;
      return storedCv();
    }
  }
  function isValid(cvValue) {
    /// <summary>
    /// Public Correlation Vector method to check for valid serialized Correlation Vector values
    /// </summary>
    /// <param name="cv" type="string">The Correlation Vector string to be validated</param>
    /// <returns type="boolean">True if the input string represents a valid serialized Correlation Vector, false otherwise.</returns>
    if (cvValue) {
      var baseValue = cvValue.split(".")[0];
      if (baseValue) {
        if (baseValue.length === 16) {
          cvVersionAtLatestValidityCheck = 1;
          return validateWithCv1(cvValue);
        } else if (baseValue.length === 22) {
          cvVersionAtLatestValidityCheck = 2;
          return validateWithCv2(cvValue);
        }
      }
    }
  }
  function validateWithCv1(cv) {
    if (cv1Constants.validationPattern.test(cv) && cv.length <= cv1Constants.maxCorrelationVectorLength) {
      return true;
    }
  }
  function validateWithCv2(cv) {
    if (cv2Constants.validationPattern.test(cv) && cv.length <= cv2Constants.maxCorrelationVectorLength) {
      return true;
    }
  }
  function isLeqThanMaxCorrelationVectorLength(length) {
    if (cvVersionAtLatestValidityCheck === 1) {
      return length <= cv1Constants.maxCorrelationVectorLength;
    } else {
      return length <= cv2Constants.maxCorrelationVectorLength;
    }
  }
  function useCv1() {
    currentCvConstants = cv1Constants;
  }
  function useCv2() {
    currentCvConstants = cv2Constants;
  }
  return {
    header: header,
    tag: eventTag,
    isInit: isInit,
    canExtend: canExtend,
    canIncrement: canIncrement,
    getValue: getValue,
    setValue: setValue,
    init: init,
    extend: extend,
    increment: increment,
    incrementExternal: incrementExternal,
    isValid: isValid,
    useCv1: useCv1,
    useCv2: useCv2
  };
})();
// -----------------------------------------------------------------------
//  <copyright file="logger.ts" company="Microsoft">
//      Copyright (c) Microsoft. All rights reserved.
//  </copyright>
//  <summary>
//      This module contains loggin methods
//  </summary>
// -----------------------------------------------------------------------
awa.logger = (function () {
  function logError(message) {
    /// <summary>
    /// Logs the given message to the console as an error.
    /// </summary>
    /// <param name="message" type="String">The message to log.</param>
    if (awa.consoleVerbosity >= awa.verbosityLevels.ERROR && console && console.error) {
      console.error("JSLL: " + message);
    }
  }
  function logWarning(message) {
    /// <summary>
    /// Logs the given message to the console as a warning.
    /// </summary>
    /// <param name="message" type="String">The message to log.</param>
    if (awa.consoleVerbosity >= awa.verbosityLevels.WARNING && console && console.warn) {
      console.warn("JSLL: " + message);
    }
  }
  function logInformation(message) {
    /// <summary>
    /// Logs the given message to the console as a informational.
    /// </summary>
    /// <param name="message" type="String">The message to log.</param>
    if (awa.consoleVerbosity >= awa.verbosityLevels.INFORMATION && console && console.log) {
      console.log("JSLL: " + message);
    }
  }
  return {
    logError: logError,
    logWarning: logWarning,
    logInformation: logInformation
  };
})();
// -----------------------------------------------------------------------
//  <copyright file="capabilityCheck.ts" company="Microsoft">
//      Copyright (c) Microsoft. All rights reserved.
//  </copyright>
//  <summary>
//      This module contains capabilities checks.
//      Eg: JSON stringify;
//  </summary>
// -----------------------------------------------------------------------
awa.capabilitiesCheck = (function () {
  return function () {
    if (!JSON || !JSON.stringify) {
      awa.logger.logError("Unable to write event: the global JSON.stringify method does not exist");
      awa.isAvailable = false;
      return false;
    }
  };
})();
// -----------------------------------------------------------------------
//  <copyright file="utils.ts" company="Microsoft">
//      Copyright (c) Microsoft. All rights reserved.
//  </copyright>
//  <summary>
//      This module contains the generic utilities
//  </summary>
// -----------------------------------------------------------------------
awa.utils = (function () {
  var os = "";
  var userAgent = "";
  var windowPerformanceTiming = window.performance ? window.performance.timing : undefined;
  var APPIDPREFIX = "JS:";
  var attributeToLookFor = "";
  /// <summary>
  /// stringifyField
  /// </summary>
  /// <param name="type" type="string">The field name.</param>
  /// <param name="value">The value to convert to string.</param>
  /// <returns type="string"></returns>
  function stringifyField(fieldName, value) {
    if (value) {
      try {
        var stringified = JSON.stringify(value);
        if (stringified === "{}") {
          if (fieldName === "timing") {
            return stringifyWindowPerformanceTiming();
          }
        }
        return stringified;
      } catch (e) {
        // JSON.Strigify has issues with circular references.
        // http://stackoverflow.com/questions/4816099/chrome-sendrequest-error-typeerror-converting-circular-structure-to-json
        var message = '{"error": "ERROR: could not stringify {0} {1}"}';
        var token = typeof value === "string" ? value : "";
        return message.replace("{0}", fieldName).replace("{1}", token);
      }
    }
  }
  /// <summary>
  /// stringifyWindowPerformanceTiming
  /// safari does not serialize window.performance.timing, therefore this shim is necessary.
  /// </summary>
  /// <returns type="string">stringified window.performance.timing</returns>
  function stringifyWindowPerformanceTiming() {
    var WPTfields = [
      "navigationStart",
      "unloadEventStart",
      "unloadEventEnd",
      "redirectStart",
      "redirectEnd",
      "fetchStart",
      "domainLookupStart",
      "domainLookupEnd",
      "connectStart",
      "connectEnd",
      "secureConnectionStart",
      "requestStart",
      "responseStart",
      "responseEnd",
      "domLoading",
      "domInteractive",
      "domContentLoadedEventStart",
      "domContentLoadedEventEnd",
      "domComplete",
      "loadEventStart",
      "loadEventEnd"
    ];
    var performanceString = "{";
    for (var i = 0; i < WPTfields.length; i++) {
      var WindowPerformanceTimingTempValue = windowPerformanceTiming[WPTfields[i]];
      if (isValueAssigned(WindowPerformanceTimingTempValue)) {
        performanceString += '"' + WPTfields[i] + '":' + WindowPerformanceTimingTempValue;
        if (i < WPTfields.length - 1) {
          performanceString += ",";
        }
      }
    }
    performanceString += "}";
    return performanceString;
  }
  /// <summary>
  /// getMuidHost
  /// </summary>
  /// <param name="type" type="string">The site root domain.</param>
  /// <returns type="string">the muidHost</returns>
  function getMuidHost(rootDomain) {
    var supportedMuidHosts = {
      "microsoft.com": "c1.microsoft.com",
      "xbox.com": "c.xbox.com",
      "live.com": "c.live.com",
      "microsoftstore.com": "c.microsoftstore.com",
      "msn.com": "c.msn.com",
      "windows.com": "c.windows.com"
    };
    return supportedMuidHosts[rootDomain];
  }
  function isOfCorrectType(type, value) {
    /// <summary>
    /// isOfCorrectType
    /// Given a type and a value, verifies whether the value is of the specified type.  As per
    /// the CS 2.0 spec, dates are treated like strings.
    /// </summary>
    /// <param name="type" type="string">The expected bond type of the value.</param>
    /// <param name="value">The value to verify.</param>
    /// <returns type="boolean">True if value is of the specified type, false otherwise.</returns>
    if (type === "string") {
      return typeof value === "string" || value instanceof String || value instanceof Date;
    } else if (type === "bool") {
      return typeof value === "boolean" || value instanceof Boolean;
    } else {
      if (!(typeof value === "number" || value instanceof Number)) {
        return false;
      }
      if (type === "uint8") {
        if (value < 0 || value > 255 || value % 1 !== 0) {
          return false;
        }
      } else if (type === "uint16") {
        if (value < 0 || value > 65535 || value % 1 !== 0) {
          return false;
        }
      } else if (type === "uint32") {
        if (value < 0 || value > 4294967295 || value % 1 !== 0) {
          return false;
        }
      } else if (type === "uint64") {
        if (value < 0 || value > 18446744073709551615 || value % 1 !== 0) {
          return false;
        }
      } else if (type === "int8") {
        if (value < -128 || value > 127 || value % 1 !== 0) {
          return false;
        }
      } else if (type === "int16") {
        if (value < -32768 || value > 32767 || value % 1 !== 0) {
          return false;
        }
      } else if (type === "int32") {
        if (value < -2147483648 || value > 2147483647 || value % 1 !== 0) {
          return false;
        }
      } else if (type === "int64") {
        if (value < -9223372036854775808 || value > 9223372036854775807 || value % 1 !== 0) {
          return false;
        }
      } else if (type === "float") {
        if (value < -3.402823e38 || value > 3.402823e38) {
          return false;
        }
      } else if (type === "double") {
        if (value < -Number.MAX_VALUE || value > Number.MAX_VALUE) {
          return false;
        }
      }
      return true;
    }
  }
  function getOs() {
    if (os === "") {
      var lowercaseUserAgent = getUserAgent().toLowerCase();
      if (lowercaseUserAgent.indexOf("windows phone") !== -1) {
        os = "WindowsPhone";
      } else if (lowercaseUserAgent.indexOf("win") !== -1) {
        os = "Windows";
      } else if (lowercaseUserAgent.indexOf("mac") !== -1) {
        os = "MacOS";
      } else if (lowercaseUserAgent.indexOf("x11") !== -1) {
        os = "Unix";
      } else if (lowercaseUserAgent.indexOf("android") !== -1) {
        os = "Android";
      } else if (lowercaseUserAgent.indexOf("linux") !== -1) {
        os = "Linux";
      } else if (lowercaseUserAgent.indexOf("webos") !== -1) {
        os = "webOS";
      } else if (lowercaseUserAgent.indexOf("blackberry") !== -1) {
        os = "BlackBerry";
      } else if (
        lowercaseUserAgent.indexOf("ipod") !== -1 ||
        lowercaseUserAgent.indexOf("ipad") !== -1 ||
        lowercaseUserAgent.indexOf("iphone") !== -1
      ) {
        os = "iOS";
      } else if (lowercaseUserAgent.indexOf("symbian") !== -1) {
        os = "Symbian";
      } else if (lowercaseUserAgent.indexOf("nokia") !== -1) {
        os = "Nokia";
      } else {
        os = "Unknown";
      }
    }
    return os;
  }
  function readAndAssignUserAgent() {
    userAgent = window.navigator && window.navigator.userAgent ? window.navigator.userAgent : "";
  }
  function getUserAgent() {
    if (userAgent === "") {
      readAndAssignUserAgent();
    }
    return userAgent;
  }
  function extractFieldFromObject(obj, fieldName) {
    /// <summary>Returns the specified field and also removes the property from the object if exists. </summary>
    /// <param type="Object">The object</param>
    /// <param type="String">Name of the field/property to be extracted</param>
    /// <returns type="String">Value of the specified tag</returns>
    var fieldValue;
    if (obj && obj[fieldName]) {
      fieldValue = obj[fieldName];
      delete obj[fieldName];
    }
    return fieldValue;
  }
  function isElementTrulyVisible(element, viewportBoundingRect) {
    /// <summary> determines if an element is currently visible to the user </summary>
    /// <param type="dom element">element to check for visibility</param>
    /// <returns type="bool"> true if element is truly visible</returns>
    element = returnDomObjectIfjQuery(element);
    var rect = element.getBoundingClientRect();
    var intersectionArea = getIntersectionArea(rect, viewportBoundingRect);
    if (intersectionArea > 0) {
      return true;
    } else {
      return false;
    }
  }
  function getIntersectionArea(rect1, rect2) {
    /// <summary> gets intersection area of two rectangles </summary>
    /// <param type="object"> object containing top, left, right, and bottom numbers </param>
    /// <param type="object"> object containing top, left, right, and bottom numbers </param>
    /// <returns type="number"> intersection area in px^2 </returns>
    var x11 = rect1.left,
      y11 = rect1.top,
      x12 = rect1.right,
      y12 = rect1.bottom,
      x21 = rect2.left,
      y21 = rect2.top,
      x22 = rect2.right,
      y22 = rect2.bottom;
    var x_overlap = Math.max(0, Math.min(x12, x22) - Math.max(x11, x21));
    var y_overlap = Math.max(0, Math.min(y12, y22) - Math.max(y11, y21));
    return x_overlap * y_overlap;
  }
  function returnDomObjectIfjQuery(element) {
    /// <summary> some elements might be jQuery, do not have method getAttribute </summary>
    /// <param type="object"> DOM or jQuery element</param>
    /// <returns> DOM element </returns>
    if (typeof jQuery === "function" && element instanceof jQuery) {
      return element[0];
    }
    return element;
  }
  // Older browsers (IE8-) doesn't support toISOString.  Add our own implementation as needed.
  function pad(number) {
    var r = String(number);
    if (r.length === 1) {
      r = "0" + r;
    }
    return r;
  }
  function dateToISOString(date) {
    return (
      date.getUTCFullYear() +
      "-" +
      pad(date.getUTCMonth() + 1) +
      "-" +
      pad(date.getUTCDate()) +
      "T" +
      pad(date.getUTCHours()) +
      ":" +
      pad(date.getUTCMinutes()) +
      ":" +
      pad(date.getUTCSeconds()) +
      "." +
      String((date.getUTCMilliseconds() / 1000).toFixed(3)).slice(2, 5) +
      "Z"
    );
  }
  var extend = function () {
    /// <summary> Pass in the objects to merge as arguments </summary>
    /// <param type="Object"> pass in as many objects as you want. For a deep extend, set the first argument to `true`</param>
    /// <returns> extended object </returns>
    // Variables
    var extended = {};
    var deep = false;
    var i = 0;
    var length = arguments.length;
    // Check if a deep merge
    if (Object.prototype.toString.call(arguments[0]) === "[object Boolean]") {
      deep = arguments[0];
      i++;
    }
    // Merge the object into the extended object
    var merge = function (obj) {
      for (var prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
          // If deep merge and property is an object, merge properties
          if (deep && Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = extend(true, extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };
    // Loop through each object and conduct a merge
    for (; i < length; i++) {
      var obj = arguments[i];
      merge(obj);
    }
    return extended;
  };
  function getPerformanceData() {
    /// <summary>
    ///  Gets performance data from the window.performance object.
    /// </summary>
    /// <returns type="Object">Performance data object</returns>
    var performanceData;
    try {
      performanceData = window.performance.getEntries().filter(function (item) {
        return item.initiatorType === "script" || item.initiatorType === "link";
      });
    } catch (ex) {}
    return performanceData;
  }
  function getPageLoadTime() {
    /// <summary>
    ///  Gets PageLoadTime of the current page.
    /// </summary>
    /// <returns type="int">Page load time in Milliseconds</returns>
    var pageLoadTime = undefined;
    if (windowPerformanceTiming.loadEventStart && windowPerformanceTiming.navigationStart) {
      if (windowPerformanceTiming.loadEventStart > 0) {
        pageLoadTime = windowPerformanceTiming.loadEventStart - windowPerformanceTiming.navigationStart;
      }
    }
    return pageLoadTime;
  }
  function bracketIt(str) {
    /// <summary>
    ///  Adds surrounding square brackets to the passed in text
    /// </summary>
    return "[" + str + "]";
  }
  function findClosestByAttribute(el, attribute) {
    /// <summary> Walks up DOM tree to find element with attribute </summary>
    /// <param type="object"> DOM element </param>
    /// <param type="string"> Attribute name </param>
    /// <returns> Dom element which contains attribute</returns>
    attributeToLookFor = attribute;
    return walkUpDomChainWithElementValidation(el, isAttributeInElement);
  }
  function findClosestAnchor(el) {
    /// <summary> Walks up DOM tree to find anchor element </summary>
    /// <param type="object"> DOM element </param>
    /// <returns> Dom element which is an anchor</returns>
    return walkUpDomChainWithElementValidation(el, isElementAnAnchor);
  }
  function walkUpDomChainWithElementValidation(el, validationMethod) {
    /// <summary> Walks up DOM tree to find element which matches validationMethod</summary>
    /// <param type="object"> DOM element </param>
    /// <param type="function"> DOM element validation method</param>
    /// <returns> Dom element which is an anchor</returns>
    var element = el;
    if (element) {
      element = returnDomObjectIfjQuery(element);
      while (!validationMethod(element)) {
        element = element.parentNode;
        element = returnDomObjectIfjQuery(element);
        if (!element || !element.getAttribute) {
          return null;
        }
      }
      return element;
    }
  }
  function isAttributeInElement(element) {
    /// <summary> method checks if attribute is in element.
    /// method checks for empty string, in case the attribute is set but no value is assigned to it </summary>
    /// <param type="object"> DOM element </param>
    /// <return type="bool"> true if attribute is in element, even if empty string </param>
    var value = element.getAttribute(attributeToLookFor);
    return isValueAssigned(value) || value === "";
  }
  function isElementAnAnchor(element) {
    return element.nodeName === "A";
  }
  function getAppIdWithPrefix(appId) {
    /// <summary> Check if appId has a colon as the third character. If it does
    /// do nothing otherwise prefix it with "JS:".A colon is valid in an appId.</summary>
    /// <param type="string"> appId </param>
    /// <returns> An appId with js:prefix</returns>
    var result;
    if (appId) {
      var appIdArray = appId.split(":");
      result = appIdArray.length > 1 && appIdArray[0].toLowerCase() === "js" ? appId : APPIDPREFIX + appId;
    }
    return result;
  }
  function removeInvalidElements(object) {
    /// <summary> Finds attributes in object which are invalid
    /// and deletes them. useful in override config </summary>
    /// <remarks> Because the config object "callback" contains only functions,
    /// when it is stringified it returns the empty object. This explains
    /// the workaround regarding "callback" </remarks>
    /// <param type="object">override config object</param>
    for (var property in object) {
      if (
        !isValueAssigned(object[property]) ||
        (JSON.stringify(object[property]) === "{}" && property !== "callback")
      ) {
        delete object[property];
      }
    }
  }
  function isValueAssigned(value) {
    /// <summary> takes a value and checks for undefined, null and empty string </summary>
    /// <param type="any"> value to be tested </param>
    /// <returns> true if value is null undefined or emptyString </returns>
    return !(value === undefined || value === null || value === "");
  }
  function removeNonObjectsAndInvalidElements(overrideConfig, attributeNamesExpectedObjects) {
    /// <summary> Finds attributes in overrideConfig which are invalid or should be objects
    /// and deletes them. useful in override config</summary>
    /// <param type="object">override config object</param>
    /// <param type=""> attributes that should be objects in override config object </param>
    removeInvalidElements(overrideConfig);
    for (var i in attributeNamesExpectedObjects) {
      var objectName = attributeNamesExpectedObjects[i];
      if (typeof overrideConfig[objectName] === "object") {
        removeInvalidElements(overrideConfig[objectName]);
      } else {
        delete overrideConfig[objectName];
      }
    }
  }
  return {
    stringifyField: stringifyField,
    getMuidHost: getMuidHost,
    isOfCorrectType: isOfCorrectType,
    getOs: getOs,
    getUserAgent: getUserAgent,
    extractFieldFromObject: extractFieldFromObject,
    isElementTrulyVisible: isElementTrulyVisible,
    dateToISOString: dateToISOString,
    extend: extend,
    returnDomObjectIfjQuery: returnDomObjectIfjQuery,
    findClosestByAttribute: findClosestByAttribute,
    findClosestAnchor: findClosestAnchor,
    getPerformanceData: getPerformanceData,
    getPageLoadTime: getPageLoadTime,
    removeInvalidElements: removeInvalidElements,
    removeNonObjectsAndInvalidElements: removeNonObjectsAndInvalidElements,
    bracketIt: bracketIt,
    getAppIdWithPrefix: getAppIdWithPrefix,
    isValueAssigned: isValueAssigned,
    ///#DEBUG
    testHook: {
      getIntersectionArea: getIntersectionArea
    } ///#ENDDEBUG
  };
})();
// -----------------------------------------------------------------------
//  <copyright file="ids.ts" company="Microsoft">
//      Copyright (c) Microsoft. All rights reserved.
//  </copyright>
//  <summary>
//      This module contains the generic id utilities
//  </summary>
// -----------------------------------------------------------------------
awa.ids = (function () {
  var impressionGuid = createGuid(),
    cookie = awa.cookie,
    appUserId = null,
    appExpId = null,
    firstImpressionGuidSent = false,
    expIdCookieName = "Treatments",
    deviceClass,
    // Must update to Common Schema Bond v2.3.2.
    // Limit support to i, w, and c; make logging accidental PII data more difficult.
    userIdPrefixes = [
      "c:",
      "i:",
      "w:" // domain user id as hash
    ],
    flightIdNameSpaces = [
      "AX",
      "EX",
      "SF",
      "CS",
      "CF",
      "CT",
      "CU",
      "DC",
      "DF",
      "H5",
      "HL",
      "WS",
      "WP" // WINDOWSPHONE
    ];
  function createGuid() {
    var guidPattern = "xxxxxxxx-xxxx-4xxx-Rxxx-xxxxxxxxxxxx";
    function randomHexDigit() {
      return Math.floor(Math.random() * 16).toString(16);
    }
    var result = guidPattern.replace(/x/g, randomHexDigit);
    // update remaining 2 bits of first digit of the clock_seq_hi_and_reserved:
    return result.replace("R", (8 | Math.floor(Math.random() * 3)).toString(16));
  }
  function visitorId(allCookies) {
    if (allCookies) {
      return allCookies["MUID"];
    } else {
      return cookie.getCookie("MUID");
    }
  }
  function getImpressionGuid() {
    return impressionGuid;
  }
  function getPageViewImpressionGuid() {
    if (firstImpressionGuidSent) {
      impressionGuid = createGuid();
    } else {
      firstImpressionGuidSent = true;
    }
    return impressionGuid;
  }
  function groups(allCookies) {
    if (allCookies) {
      return allCookies[expIdCookieName];
    } else {
      return cookie.getCookie(expIdCookieName);
    }
  }
  function muidUserId(allCookies) {
    var muidValue = "";
    if (allCookies) {
      muidValue = allCookies["MUID"];
    } else {
      muidValue = cookie.getCookie("MUID");
    }
    return muidValue && muidValue.length ? "t:" + muidValue : muidValue;
  }
  /// Set app user id.
  function setAppUserId(uid) {
    appUserId = null; // Make sure to reset the last user id.
    if (!uid) {
      return; // No need to log null or empty user ids which can be used to reset app user ids.
    }
    for (var i = 0; i < userIdPrefixes.length; i++) {
      if (userIdPrefixes[i] === uid.substring(0, 2)) {
        appUserId = uid;
        break;
      }
    }
    if (!appUserId) {
      awa.logger.logWarning("Unsupported app user id: " + uid + ". Supported app user ids are: c:, i:, and w:");
    }
  }
  function isValidAppFlightId(appFlightId) {
    /// <summary>Verify an expId against the CS2.1 spec</summary>
    /// <param type="Object">expId to verify in string format</param>
    /// <returns type="true">true if expId is valid, false otherwise</returns>
    if (!appFlightId || appFlightId.length < 4) {
      return false;
    }
    var isValid = false,
      MAXFLIGHTIDLENGTH = 256,
      curNameSpace = appFlightId.substring(0, 3).toString().toUpperCase();
    // The prefix check must include ":", else strings starting with prefixes will slip through
    for (var i = 0; i < flightIdNameSpaces.length; i++) {
      if (flightIdNameSpaces[i] + ":" === curNameSpace && appFlightId.length <= MAXFLIGHTIDLENGTH) {
        isValid = true;
        break;
      }
    }
    return isValid;
  }
  function setAppExpId(appExpIdNew) {
    /// <summary>Validate each flight id in appExpId against the app flight ID
    /// format and create a comma seperated appExpId with valid flight ids.Ignore invalid flight IDs< /summary>
    /// <param type="Object">A list of comma seperated appExpId</param>
    /// <returns type="void">none</returns>
    if (!appExpIdNew) {
      appExpId = null;
      return;
    } else if (appExpIdNew === appExpId) {
      return; // Nothing to do if seen before
    } else {
      // Reset to empty first. The new but invalid appExpId should not be logged and we cannot leave the old one hanging around
      // since it means old experiment id cannot represent the new experiment with an invalid appExpId.
      appExpId = null;
      var expIdArray = appExpIdNew.split(",");
      for (var i = 0; i < expIdArray.length; i++) {
        if (isValidAppFlightId(expIdArray[i])) {
          if (!appExpId) {
            appExpId = expIdArray[i];
          } else {
            appExpId += "," + expIdArray[i];
          }
        } else {
          awa.logger.logWarning("Unsupported flight id format for this app expId: " + expIdArray[i]);
        }
      }
    }
  }
  /// <summary>Get experiment ids based on flight ID string format.</summary>
  /// <returns type="true">Comma seperated experiment ids</returns>
  function getAppExpId() {
    return appExpId;
  }
  function setDeviceClass(newDeviceClass) {
    if (newDeviceClass) {
      deviceClass = newDeviceClass;
    }
  }
  function getDeviceClass() {
    return deviceClass;
  }
  function readExpIdFromCookieAndSetInModule(allCookies) {
    if (!allCookies) {
      setAppExpId(groups()); // groups gets the cookie value of expId cookie name
    } else {
      setAppExpId(allCookies[expIdCookieName]);
    }
    return getAppExpId();
  }
  return {
    getVisitorId: visitorId,
    getMuidUserId: muidUserId,
    setAppUserId: setAppUserId,
    getAppUserId: function () {
      return appUserId;
    },
    readExpIdFromCookie: readExpIdFromCookieAndSetInModule,
    readExpIdFromCoreData: function (expId) {
      setAppExpId(expId);
      return getAppExpId();
    },
    getImpressionGuid: getImpressionGuid,
    getPageViewImpressionGuid: getPageViewImpressionGuid,
    getGroups: groups,
    setDeviceClass: setDeviceClass,
    getDeviceClass: getDeviceClass,
    setExpIdCookieName: function (name) {
      expIdCookieName = name;
    },
    getExpIdCookieName: function () {
      return expIdCookieName;
    }
  };
})();
// -----------------------------------------------------------------------
//  <copyright file="vortexEvents.ts" company="Microsoft">
//      Copyright (c) Microsoft. All rights reserved.
//  </copyright>
//  <summary>
//      This module is a wrapper on top JSLL, it exposes all the methods that we use in JSLL, much user friendly way
//  </summary>
// -----------------------------------------------------------------------
var eventsSentInBatch = 0;
var batchesSent = 0;
var eventsNotSentInBatch = 0;

sendBatchTelemetry = function (sendImmediate) {
  var telemetryObject = {
    name: "JSLL Batch Telemetry",
    eventsSentInBatch: eventsSentInBatch,
    batchesSent: batchesSent,
    eventsNotSentInBatch: eventsNotSentInBatch
  };
  //nonStandardPushInformationEvent("jsll", JSON.stringify(telemetryObject), "SD-Telemetry",sendImmediate);
  eventsSentInBatch = 0;
  batchesSent = 0;
  eventsNotSentInBatch = 0;
};
sendBatchTelemetryImmediate = function () {
  sendBatchTelemetry(true);
};
window.setInterval(sendBatchTelemetry, 1800000); // 30 minutes 1800000
window.addEventListener("beforeunload", sendBatchTelemetryImmediate);

awa.vortexEvents = (function () {
  var ids = awa.ids;
  var nonCriticalEventsQueue = [];
  var overrideReadyState = "notInit"; // this is overwritten at init
  var numberOfEventsToBatch = 0;
  function batchQueuedEvents() {
    /// <summary> fires events in one batch </summary>
    if (nonCriticalEventsQueue.length > 0) {
      batchesSent++;
      eventsSentInBatch += nonCriticalEventsQueue.length;
      awa.writeEvent(nonCriticalEventsQueue);
      nonCriticalEventsQueue = [];
    }
  }
  function drainQueuedEvents() {
    /// <summary> fires events consecutively
    /// this method is called by Vortex at first call (through firstEventDone).
    /// If dom is not ready, wait before firing noncritical events. </summary>
    if (document.readyState === "complete") {
      while (nonCriticalEventsQueue.length > 0) {
        awa.writeEvent(nonCriticalEventsQueue.pop());
      }
    } else {
      awa.ct.onDomReadyDo(awa.firstEventDoneTasks);
    }
  }
  function sendOrScheduleEvent(event, isCriticalEvent) {
    /// <summary> queues or fires events </summary>
    /// <param type="object"> event info as parsed by vortexEvents methods </param>
    /// <param type="bool"> whether the event should be queued or sent immediately </param>
    if (isCriticalEvent === true) {
      awa.writeEvent(event);
      return;
    } else {
      if (overrideReadyState === "complete") {
        // overrideReadyState is overwritten to hold off other events
        // drainQueuedEvents is called by the first pageView
        awa.writeEvent(event);
        return;
      }
      nonCriticalEventsQueue.push(event);
      if (numberOfEventsToBatch > 1 && nonCriticalEventsQueue.length >= numberOfEventsToBatch) {
        batchQueuedEvents();
      }
    }
  }
  // TODO: remove these methods when breaking changes
  function jsllEvent(eventData) {
    var event = {};
    if (eventData.type === "CorsDisallowed") {
      awa.ct.captureCorsDisallowed(eventData);
    } else if (eventData.type === "EventTooLong") {
      awa.ct.captureEventTooLong(eventData);
    }
  }
  // TODO: remove these methods when breaking changes
  function error(errorInfo, displayedToUser) {
    awa.ct.captureClientError({
      errorInfo: errorInfo,
      displayedToUser: displayedToUser
    });
  }
  // Note: IncomingRequest is not applicable for Web
  // TODO: remove these methods when breaking changes
  function outgoingRequest(eventData) {
    /// ************* PLEASE READ BEFORE MODIFYING *********************
    /// <remarks> This is duplicate code that also exists in service.js. Be mindful when editing the code below.
    /// The method here a single JSON object as an input parameter, whereas the method in service.js
    /// uses objects that are in the service module.
    /// These methods could be merged, but the expectation is to separate
    /// the service.js into its own file downloadable from CDN. </remarks>
    var event = {
      name: "Ms.Webi.OutgoingRequest",
      cV: eventData.cV,
      data: {
        baseData: {
          operationName: eventData.currentOperationName,
          targetUri: eventData.requestUri,
          latencyMs: eventData.latencyMs,
          serviceErrorCode: eventData.serviceErrorCode || -1,
          succeeded: eventData.isSuccess,
          requestMethod: eventData.httpMethod,
          responseContentType: eventData.contentType,
          protocolStatusCode: eventData.httpStatusCode,
          dependencyOperationName: eventData.operationName,
          dependencyOperationVersion: eventData.operationVersion,
          dependencyName: eventData.serviceName,
          dependencyType: eventData.serviceType || "WebService",
          responseSizeBytes: eventData.responseSize
        },
        baseType: "Ms.Qos.OutgoingServiceRequest",
        impressionGuid: ids.getImpressionGuid(),
        message: eventData.errorMessage,
        retryCount: eventData.retryCount,
        customData: eventData.customData
      }
    };
    // call this to add pageName, Uri and Market
    awa.ct.captureQos(event);
  }
  return {
    sendError: error,
    sendApiComplete: outgoingRequest,
    sendJsllEvent: jsllEvent,
    SendOrScheduleEvent: sendOrScheduleEvent,
    // we move all of the functionality in vortexevents to
    // respective methods in ct we can revisit this.
    batchQueuedEvents: batchQueuedEvents,
    drainQueuedEvents: drainQueuedEvents,
    batchEventsByNumber: function (number) {
      numberOfEventsToBatch = number;
    },
    addEventToQueue: function (obj) {
      nonCriticalEventsQueue.push(obj);
    },
    overrideQueueBehavior: function (options) {
      if (options) {
        if (options.domReadyState) {
          overrideReadyState = options.domReadyState;
        }
      }
    }
  };
})();
// -----------------------------------------------------------------------
//  <copyright file="errorHandler.ts" company="Microsoft">
//      Copyright (c) Microsoft. All rights reserved.
//  </copyright>
//  <summary>
//      This module contains the generic Errorhandler utilities
//  </summary>
// -----------------------------------------------------------------------
awa.errorHandler = (function () {
  var vortexEvents = awa.vortexEvents;
  function windowErrorHandler(nextHandler) {
    var prevError = window.onerror;
    window.onerror = function () {
      if (prevError) {
        prevError.apply(this, arguments);
      }
      nextHandler.apply(this, arguments);
    };
  }
  function extractStackTrace(errorObject) {
    // stack not defined in ErrorEvent yet
    return errorObject.stack ? errorObject.stack.substring(0, 1000) : "";
  }
  function defaultHandler() {
    if (arguments) {
      var scriptSource = "";
      // onerror event return a Uri for script location
      if (arguments[1]) {
        var url = document.createElement("a");
        url.href = arguments[1];
        scriptSource = awa.ct.getUri(url);
      }
      var errorDetails = {
        Page: awa.ct.getUri(document.location),
        Script: scriptSource,
        Message: arguments[0] || "",
        LineNumber: arguments[2] || 0,
        StackTrace: arguments[4] ? extractStackTrace(arguments[4]) : "",
        UserAgent: awa.utils.getUserAgent() || "",
        Platform: window.navigator.platform || "" // getting deprecated
      };
      vortexEvents.sendError(errorDetails, false);
    }
    // don't use return as this would impact how browser handles
    // the errors that come to window.error, and it varies for different browsers.
  }
  function init() {
    windowErrorHandler(defaultHandler);
  }
  return { init: init };
})();
// -----------------------------------------------------------------------
//  <copyright file="service.ts" company="Microsoft">
//      Copyright (c) Microsoft. All rights reserved.
//  </copyright>
//  <summary>
//      TimeSpanHandler stores the start of an Timespan event and sends over
//      the request to Vortex when the appropriate timespan event completes
//      based on hte isComplete indicator, Developers should use unique
//      counterName's to record timespan at every usage of this event
//      to ensure consistency
//  </summary>
// -----------------------------------------------------------------------
awa.timespanHandler = (function () {
  var timers = {};
  function recordTimeSpan(counterName, isComplete) {
    var timestamp = new Date().getTime();
    if (!isComplete) {
      timers[counterName] = timestamp;
    } else {
      return timestamp - timers[counterName];
    }
  }
  return { recordTimeSpan: recordTimeSpan };
})();
// -----------------------------------------------------------------------
//  <copyright file="asimov.ts" company="Microsoft">
//      Copyright (c) Microsoft. All rights reserved.
//  </copyright>
//  <version>#NugetPackageBuildNumber#</version>
//  <summary>
//      Contains core JSLL event packaging and tranporting functionality
//  </summary>
// -----------------------------------------------------------------------
(function () {
  // Contains the registered schemas.
  awa._schemas = awa._schemas || [];
  var utils = awa.utils;
  var isValueAssigned = utils.isValueAssigned;
  // Default configuration values
  var config = {
    // General library settings
    endpoint: "https://web.vortex.data.microsoft.com/collect/v1",
    sendMode: 1,
    // sendMode N == 1 ?: all non-critical BI events are sent after the first BI event (pageView or pageAction).
    // sendMode N == 2 ?: all non-critical events are sent in a POST, batching N events at once.
    batchSize: 10,
    authMethod: 0,
    validateEvents: true,
    sendEvents: true,
    logLevel: awa.verbosityLevels.NONE,
    syncMuid: false,
    provisionMsfpc: true,
    useDefaultContentName: true,
    useShortNameForContentBlob: false,
    debounceMs: {
      scroll: 600,
      resize: 3000
    },
    muidDomain: "microsoft.com",
    biBlobAttributeTag: "data-m",
    isLoggedIn: false,
    shareAuthStatus: false,
    cookiesToCollect: ["Bounced"],
    mscomCookies: false,
    userConsentCookieName: "MSCC",
    userConsented: undefined,
    useBeacon: true,
    urlCollectHash: false,
    urlCollectQuery: true,
    initCv: false,
    enabledFeatures: true,
    ix: {
      a: false,
      g: false
    },
    autoCapture: {
      pageView: true,
      onLoad: true,
      onUnload: true,
      click: true,
      scroll: false,
      resize: false,
      jsError: true,
      addin: true,
      perf: true,
      assets: false,
      lineage: false,
      invalidEvents: false,
      msTags: true,
      awaTags: true,
      eventTooLong: true,
      corsDisallowed: true
    },
    callback: {
      pageName: null,
      pageActionPageTags: null,
      pageViewPageTags: null,
      contentUpdatePageTags: null,
      pageActionContentTags: null,
      signedinStatus: null,
      jsllEventCallback: null,
      pageUnloadTimings: null
    },
    // overrideValues JSLL should use instead of collecting automatically
    coreData: {
      referrerUri: document.referrer || undefined,
      requestUri: "",
      appId: window.location.hostname,
      pageName: "",
      title: "",
      pageType: "",
      env: "",
      product: "",
      market: "",
      serverImpressionGuid: "",
      expId: "",
      pageTags: {}
    }
  };
  awa.getConfig = function () {
    return config;
  };
  var attributesThatAreObjectsInConfig = [];
  for (var attribute in config) {
    if (typeof config[attribute] === "object") {
      attributesThatAreObjectsInConfig.push(attribute);
    }
  }
  // constants
  var CS_ENVLOPE_VERSION = "2.1";
  var JSLL_VERSION = "4.2.9";
  var JSEXTENSION_VERSION = "1.1";
  var partAfieldsInOrder = ["ver", "name", "time", "flags", "os", "appId", "cV", "deviceClass"];
  var numberOfPartAFields = partAfieldsInOrder.length;
  // local variables
  var isOldIE = isOldIEBrowser();
  var allowedGetLength = isOldIE ? 2083 : 15000; // The upper limit is constrained by the vortex endpoint, not by browser limit.
  var queryParameters = "";
  var signInRedirectCount = 0;
  var firstEventSent = false;
  var isBeaconAvailable = isValueAssigned(navigator) && isValueAssigned(navigator.sendBeacon);
  awa.experimentIdTag = "expId";
  awa.isAvailable = true;
  awa.requestBody = "";
  awa.getQueryStringParameters = function () {
    return queryParameters;
  };
  if (Object.freeze) {
    Object.freeze(awa.verbosityLevels);
  }
  awa.capabilitiesCheck();
  var requestMechanism = window.XDomainRequest ? "XDomainRequest" : "xhr";
  var canMakeCrossDomainCall = function () {
    if (requestMechanism === "XDomainRequest") {
      if (config.endpoint && config.endpoint.indexOf(window.location.protocol) !== 0) {
        awa.logger.logError("Unable to write event: CORS requests are not supported cross-protocol in this browser");
        return false;
      }
    }
    return true;
  };
  var modeOneFirstEventSent = function () {
    /// <summary>
    /// Attach to onSuccess to indicate first event sent and
    /// to drain the queued events
    /// </summary>
    /// <param name="xdr">The XDomainRequest object.</param>
    firstEventSent = true;
    if (config.sendMode == 1) {
      awa.vortexEvents.overrideQueueBehavior({ domReadyState: "complete" });
      awa.vortexEvents.drainQueuedEvents();
    }
  };
  awa.firstEventDone = modeOneFirstEventSent;
  /// <summary>
  /// method that is called ondomready since method is exported not the method call
  /// </summary>
  awa.firstEventDoneTasks = function () {
    awa.vortexEvents.drainQueuedEvents();
  };
  // SD customization
  var xhrFailureCallback = function (textStatus, errorThrown, eventsInError) {
    /// <summary>
    /// A failure callback for XHR request callbacks which outputs the result to the console.
    /// </summary>
    /// <param name="textStatus" type="String">The status of the response.</param>
    /// <param name="errorThrown" type="Object">The error thrown.</param>
    awa.logger.logError("Failure sending data to vortex: " + textStatus + "Error: " + errorThrown.toString());
    if (awa.OnFailedVortexRequest) {
      awa.OnFailedVortexRequest({ textStatus: textStatus, errorThrown: errorThrown }, eventsInError);
    }
  };
  var xhrSuccessCallback = function (src, event, isScript) {
    /// <summary>
    /// A success callback for XHR request callbacks which outputs the result to the console.
    /// </summary>
    /// <param name="src">A string representation of the call.</param>
    if (awa.OnSuccessfulVortexRequest) {
      awa.OnSuccessfulVortexRequest(src, event);
    }
    if (event && typeof config.callback.jsllEventCallback === "function") {
      config.callback.jsllEventCallback(event);
    }
    if (firstEventSent === false) {
      firstEventSent = true;
      if (config.sendMode === 1 && !isScript) {
        // if it is a script, this method is called by Vortex or by the iFrame callback
        modeOneFirstEventSent();
      }
    }
    awa.logger.logInformation("Success sending data to vortex");
  };
  // SD customization
  var xdrFailureCallback = function (xdr, eventsInError) {
    /// <summary>
    /// A failure callback for XDomainRequests called when there is a failure to send data.
    /// </summary>
    /// <param name="xdr">The XDomainRequest object.</param>
    awa.logger.logError("Failure sending data to vortex using XDomainRequest.  Status code:" + xdr.status);
    if (awa.OnFailedVortexRequest) {
      awa.OnFailedVortexRequest({ xdr: xdr }, eventsInError);
    }
  };
  var quoteCharacter = "'";
  var doubleQuoteCharacter = '"';
  var dashCharacter = "-";
  var starCharacter = "*";
  function addToQueryParam(queryParam, key, value) {
    if (isValueAssigned(value)) {
      var returnString = "";
      if (queryParam.length > 0) {
        returnString += "&";
      }
      if (utils.isOfCorrectType("number", value) || utils.isOfCorrectType("bool", value)) {
        returnString += key + "=" + value;
      } else if (typeof value == "object") {
        returnString += key + "=" + JSON.stringify(value);
      } else {
        returnString += key + "=" + quoteCharacter + encodeURIComponent(value) + quoteCharacter;
      }
      return returnString;
    } else {
      return "";
    }
  }
  function addToRequestBody(requestBody, key, value) {
    if (isValueAssigned(value)) {
      var returnString = "";
      if (requestBody.length > 1) {
        returnString += ",";
      }
      if (utils.isOfCorrectType("number", value) || utils.isOfCorrectType("bool", value)) {
        returnString += doubleQuoteCharacter + key + doubleQuoteCharacter + ":" + value;
      } else if (typeof value == "object") {
        returnString += doubleQuoteCharacter + key + doubleQuoteCharacter + ":" + JSON.stringify(value);
      } else {
        returnString +=
          doubleQuoteCharacter + key + doubleQuoteCharacter + ":" + doubleQuoteCharacter + value + doubleQuoteCharacter;
      }
      return returnString;
    } else {
      return "";
    }
  }
  function getQueryFromJSON(event, allCookies) {
    var queryParameters = "";
    // Part A
    for (var i = 0; i < numberOfPartAFields; i++) {
      queryParameters += addToQueryParam(queryParameters, partAfieldsInOrder[i], event[partAfieldsInOrder[i]]);
    }
    var data = event.data;
    for (var dataKey in data) {
      if (dataKey == "baseData") {
        var baseData = data[dataKey];
        for (var baseDataKey in baseData) {
          // Part B
          queryParameters += addToQueryParam(queryParameters, dashCharacter + baseDataKey, baseData[baseDataKey]);
        }
      } else {
        // Part C
        queryParameters += addToQueryParam(queryParameters, starCharacter + dataKey, data[dataKey]);
      }
    }
    // Extensions
    var extensions = event.ext;
    for (var extensionKey in extensions) {
      var currentExtension = extensions[extensionKey];
      for (var subExtensionKey in currentExtension) {
        queryParameters += addToQueryParam(
          queryParameters,
          "ext" + dashCharacter + extensionKey + dashCharacter + subExtensionKey,
          currentExtension[subExtensionKey]
        );
      }
    }
    queryParameters += "&" + getMsComQueryParam();
    // add isRedirected to asa.js requests
    if (config.shareAuthStatus === true && config.authMethod == 2 && getSignedInStatus() === true) {
      queryParameters += "&" + getRedirectQueryParam(allCookies);
    }
    setGlobalQueryParamForUnitTests(queryParameters);
    return queryParameters;
  }
  function getRequestBodyFromJSON(event) {
    // because the order of the fields matter to Vortex,
    // the requestBody has to be stringified
    // manually
    var openingCurl = "{";
    var closingCurl = "}";
    var requestBody = openingCurl;
    // Part A
    for (var i = 0; i < numberOfPartAFields; i++) {
      requestBody += addToRequestBody(requestBody, partAfieldsInOrder[i], event[partAfieldsInOrder[i]]);
    }
    var data = event.data;
    if (data) {
      requestBody += addToRequestBody(requestBody, "data", data);
    }
    // Extensions
    var extensions = event.ext;
    if (extensions) {
      requestBody += addToRequestBody(requestBody, "ext", extensions);
    }
    requestBody += closingCurl;
    // set awa.requestBody for unit tests
    awa.requestBody = requestBody;
    return requestBody;
  }
  function setGlobalQueryParamForUnitTests(queryP) {
    queryParameters = queryP;
  }
  awa.init = function (overrideConfig) {
    /// <summary>
    ///  Initialization function for asimov object.
    /// </summary>
    /// <param name="config">The configuration object.
    /// For config object schema please see: https://osgwiki.com/wiki/JSLLv4#Changing_Default_Configurations
    /// </param>
    // Validate incoming config as necessary and merge with default config.
    if (!awa.isInitialized) {
      awa.isInitialized = true;
      if (overrideConfig) {
        // delete attributes that should be object and
        // delete properties that are null, undefined, ""
        utils.removeNonObjectsAndInvalidElements(overrideConfig, attributesThatAreObjectsInConfig);
        config = utils.extend(true, config, overrideConfig);
      }
      var sendMode = config.sendMode;
      if (sendMode == 0) {
        // events flow as is
        firstEventSent = true;
        awa.vortexEvents.overrideQueueBehavior({ domReadyState: "complete" });
      }
      if (sendMode >= 1) {
        // events blocked until first success
        awa.vortexEvents.overrideQueueBehavior({ domReadyState: "notComplete" });
      }
      if (sendMode === 2) {
        // critical events go through, non-critical are batched
        awa.vortexEvents.batchEventsByNumber(config.batchSize);
      }
      awa.consoleVerbosity = config.logLevel; // default to no console logging
      awa.ct.initialize(config);
      awa.ix.init(config);
      if (config.initCv) {
        awa.cv.init();
      }
    }
  };
  var populatePartAandExtensions = function (event, allCookies) {
    // translates event from previous structure to final Asimov structure
    if (awa.translateEventFromIntermediateStructure) {
      event = awa.translateEventFromIntermediateStructure(event);
    }
    // add partA and extensions
    /// <summary> method that returns a JSON object with all event partA</summary>
    /// <returns> JSON object with partA </returns>
    var cV = event.cV;
    var appId = event.appId;
    event.ver = "2.1";
    event.cV = isValueAssigned(cV) ? cV : awa.cv.getValue();
    event.time = isValueAssigned(event.time) ? event.time : utils.dateToISOString(new Date());
    event.os = utils.getOs();
    event.deviceClass = awa.ids.getDeviceClass() || undefined;
    event.appId = utils.getAppIdWithPrefix(appId ? appId : config.coreData.appId);
    // check for non-cached domain
    var domain = window.location.hostname;
    if (!isValueAssigned(domain)) {
      domain = window.location.protocol == "file:" ? "local" : domain;
    }
    // create extensions object and javascript extension
    var javascriptExtensionObject = {
      ver: "1.1",
      libVer: "4.2.9",
      domain: domain,
      msfpc: allCookies["MSFPC"],
      userConsent: isValueAssigned(config.userConsented)
        ? config.userConsented
        : isValueAssigned(allCookies[config.userConsentCookieName])
        ? true
        : false,
      anid: allCookies["ANON"] ? allCookies["ANON"].slice(0, 34) : undefined // remove E & W
    };
    var serviceName = event.serviceName ? event.serviceName : config.coreData.serviceName;
    if (serviceName) {
      javascriptExtensionObject.serviceName = serviceName;
    }
    // if env has created the ext object or not
    if (event.ext) {
      event.ext.javascript = javascriptExtensionObject;
    } else {
      event.ext = {
        javascript: javascriptExtensionObject
      };
    }
    // user extensions
    var localId = awa.ids.getMuidUserId(allCookies);
    if (localId) {
      event.ext.user = {
        localId: localId
      };
    }
    // app Extension
    // check for env that might be set in CT
    var configEnv = config.coreData.env;
    var envFromCT = event.ext.app ? event.ext.app.env : undefined;
    var envValue = isValueAssigned(envFromCT) ? envFromCT : configEnv;
    var expIdValue = config.coreData.expId
      ? awa.ids.readExpIdFromCoreData(config.coreData.expId)
      : awa.ids.readExpIdFromCookie(allCookies);
    var userIdValue = awa.ids.getAppUserId();
    if (isValueAssigned(envValue) || isValueAssigned(expIdValue) || isValueAssigned(userIdValue)) {
      if (!event.ext.app) {
        event.ext.app = {};
      }
      if (envValue) {
        event.ext.app.env = envValue;
      }
      if (expIdValue) {
        event.ext.app.expId = expIdValue;
      }
      if (userIdValue) {
        event.ext.app.userId = userIdValue;
      }
    }
    if (config.validateEvents && awa.isEventValid && !awa.isEventValid(event)) {
      return undefined;
    } else {
      awa._validateAndTranslateEvent(event);
      return event;
    }
  };
  awa.writeEvent = function (event, doNotRetryOnError) {
    // Jsll.ICustomEvent
    /// <summary>
    /// Writes one or more events to the configured asimov endpoint.  Given an event, or an array of events,
    /// it validates each event against the schema for the event type outputting any validation errors to the
    /// console.  Valid events are then batched together and sent to the asimov endpoint.  Only one event can
    /// be sent at a time using get.  This will fall back to post if the event is too large, or if multiple events
    /// are passed in.
    /// </summary>
    /// <param name="event">An event or an array of events.</param>
    // if not initialized, send event to queue
    if (!awa.isInitialized) {
      awa.vortexEvents.addEventToQueue(event);
      return;
    }
    var actuallyUseGet = true;
    var allCookies = awa.cookie.getAllCookies();
    var isMsfpcProvisioned = isValueAssigned(allCookies["MSFPC"]);
    // translate the events
    if (Object.prototype.toString.call(event) === "[object Array]") {
      var arrayOfEventsToSend = [];
      for (var i = 0; i < event.length; i++) {
        var currentEvent = populatePartAandExtensions(event[i], allCookies);
        if (currentEvent) {
          arrayOfEventsToSend.push(currentEvent);
        }
      }
      if (arrayOfEventsToSend.length != 0) {
        event = arrayOfEventsToSend;
        actuallyUseGet = false;
      } else {
        return;
      }
    } else {
      eventsNotSentInBatch++;
      event = populatePartAandExtensions(event, allCookies);
      if (!event) {
        return;
      }
    }
    if (config.sendEvents) {
      // escape "get" parameter and check our final uri length
      // endpoint + "/t.gif?" + encoded Vortex GET query parameters
      var payloadLength = JSON.stringify(event).length + config.endpoint.length;
      if (actuallyUseGet && payloadLength + 7 > allowedGetLength) {
        awa.logger.logWarning("event is too large to send using get -- using post instead");
        if (config.autoCapture.eventTooLong) {
          // Log EventTooLong event
          var jsllEvent = {};
          jsllEvent.eventName = event.name;
          jsllEvent.payloadLength = payloadLength;
          awa.ct.captureEventTooLong(jsllEvent);
        }
        actuallyUseGet = false;
      }
      if (!actuallyUseGet && !canMakeCrossDomainCall()) {
        if (config.autoCapture.corsDisallowed) {
          var jsllEvent = {};
          jsllEvent.eventName = event.name;
          jsllEvent.type = "CorsDisallowed";
          awa.ct.captureCorsDisallowed(jsllEvent);
        }
        return;
      }
      ///#DEBUG
      if (awa.testHook && awa.testHook.testUsePost == true) {
        actuallyUseGet = false;
      }
      ///#ENDDEBUG
      // Use image to send event if Get is being used.
      if (actuallyUseGet) {
        if (
          firstEventSent === false ||
          (config.provisionMsfpc && !isMsfpcProvisioned) ||
          config.shareAuthStatus === true
        ) {
          isMsfpcProvisioned = true;
          var telemetryResource = "/t.js";
          if (config.shareAuthStatus === true && getSignedInStatus() === true) {
            if (config.authMethod === 1) {
              var isAlreadyAuthed = isValueAssigned(allCookies["Bounced"]);
              if (isAlreadyAuthed) {
                sendThroughImage(config.endpoint + "/asm.gif?" + getQueryFromJSON(event, allCookies), event);
                return;
              } else {
                telemetryResource = "/asm.js";
              }
            } else if (config.authMethod === 2) {
              telemetryResource = "/asa.js";
            }
          }
          sendThroughScript(
            config.endpoint + telemetryResource + "?" + getQueryFromJSON(event, allCookies),
            event,
            doNotRetryOnError
          );
        } else {
          if (isBeaconAvailable && config.useBeacon === true) {
            // Vortex does not crack msa/aad token for POST requests. Disabling Beacon for authenticated requests until Vortex support is enabled.
            sendThroughBeacon(event);
          } else {
            sendThroughImage(config.endpoint + "/t.gif?" + getQueryFromJSON(event, allCookies), event);
          }
        }
      } else {
        if (isBeaconAvailable && config.useBeacon === true && config.shareAuthStatus === false) {
          sendThroughBeacon(event);
        } else {
          sendThroughPost(event);
        }
      }
    } else {
      xhrSuccessCallback(getQueryFromJSON(event, allCookies), event);
    }
  };
  function sendThroughImage(imageSrc, event) {
    var newImage = new Image();
    newImage.onload = function () {
      if (newImage.width === 1) {
        xhrSuccessCallback(imageSrc, event);
      }
    };
    newImage.onerror = function () {
      awa.logger.logWarning("Telemetry image beacon not sent properly. Sending through POST.");
      sendThroughPost(event);
    };
    newImage.src = imageSrc;
  }
  function serializeEventForPost(translatedEvents) {
    /// <summary> serializes the event(s) and returns an array used in beacon and posts </summary>
    /// <params> event as passed from writeEvent </params>
    /// <returns> object with qp, requestBody, and requestSrc </returns>
    var requestBody = "";
    var qp = "";
    var msfpc = "";
    if (translatedEvents.length) {
      msfpc = translatedEvents[0].ext.javascript.msfpc;
      for (var j = 0; j < translatedEvents.length; j++) {
        if (j > 0) {
          requestBody += "\n";
        }
        var sdUniqueId = translatedEvents[j]["__sd_unique_id"];
        delete translatedEvents[j]["__sd_unique_id"];
        requestBody += getRequestBodyFromJSON(translatedEvents[j]);
        translatedEvents[j]["__sd_unique_id"] = sdUniqueId;
      }
    } else {
      msfpc = translatedEvents.ext.javascript.msfpc;
      requestBody = getRequestBodyFromJSON(translatedEvents);
    }
    var requestSrc = config.endpoint + "/t.req?" + requestBody;
    var qp = "?" + getMsComQueryParam();
    qp += isValueAssigned(msfpc)
      ? "&ext-javascript-msfpc=" + encodeURIComponent(quoteCharacter + msfpc + quoteCharacter)
      : "";
    return {
      qp: qp,
      requestBody: requestBody,
      requestSrc: requestSrc
    };
  }
  function getMsComQueryParam() {
    /// <summary> this method is called twice (get and post)
    /// <returns> query parameter kvp for vortex signal collectMsComCookies
    return "$mscomCookies=" + config.mscomCookies;
  }
  function getRedirectQueryParam(allCookies) {
    return "$nr=" + isValueAssigned(allCookies["Bounced"]);
  }
  function sendThroughPost(translatedEvents) {
    var serializedEvent = serializeEventForPost(translatedEvents);
    if (requestMechanism === "xhr") {
      var request = new XMLHttpRequest();
      request.open("POST", config.endpoint + serializedEvent.qp, true);
      request.withCredentials = true;
      request.onload = function () {
        if (request.status === 200) {
          xhrSuccessCallback(serializedEvent.requestSrc, translatedEvents);
        } else {
          xhrFailureCallback(request.statusText, request.status, translatedEvents);
        }
      };
      request.onerror = function () {
        xhrFailureCallback(request.statusText, request.status, translatedEvents);
      };
      request.send(serializedEvent.requestBody);
    } else if (requestMechanism === "XDomainRequest") {
      var xdr = new window.XDomainRequest();
      xdr.onload = function () {
        xhrSuccessCallback(serializedEvent.requestSrc, translatedEvents);
      };
      xdr.onerror = function () {
        xdrFailureCallback(xdr, translatedEvents);
      };
      xdr.open("POST", config.endpoint);
      xdr.send(serializedEvent.requestBody);
    } else {
      awa.logger.logError("No event is sent.");
    }
  }
  function sendThroughBeacon(translatedEvents) {
    var serializedEvent = serializeEventForPost(translatedEvents);
    if (navigator.sendBeacon(config.endpoint + serializedEvent.qp, serializedEvent.requestBody)) {
      // if successful:
      xhrSuccessCallback(serializedEvent.requestSrc, translatedEvents);
    } else {
      // failure might be due to size. If fail, go to POST
      sendThroughPost(translatedEvents);
    }
  }
  function sendThroughScript(scriptSrc, event, doNotRetryOnError) {
    var head = document.head || document.getElementsByTagName("head")[0] || document.documentElement;
    var script = document.createElement("script");
    script.onload = function () {
      xhrSuccessCallback(scriptSrc, event, true);
    };
    script.onerror = function () {
      if (doNotRetryOnError) {
        awa.logger.logError("No event is sent.");
      } else {
        modeOneFirstEventSent();
        awa.writeEvent(event, true);
      }
    };
    script.async = true;
    script.src = scriptSrc;
    head.appendChild(script);
  }
  function getSignedInStatus() {
    if (config.callback && typeof config.callback.signedinStatus === "function") {
      return config.callback.signedinStatus();
    } else {
      return config.isLoggedIn;
    }
  }
  // This method is not referenced here in code.  Its used by the dynamically generated script from Vortex for authentication calls.
  awa.sendEventThroughIframe = function (frameSrc) {
    var frame = document.createElement("iframe");
    frame.id = "telframe";
    frame.style.display = "none";
    // MSA will onload properly. AAD will require script execution from vortex
    if (config.authMethod == 1) {
      if (frame.addEventListener) {
        frame.addEventListener("load", modeOneFirstEventSent);
      } else {
        frame.attachEvent("onload", modeOneFirstEventSent);
      }
    }
    frame.src = frameSrc;
    // redirects
    awa.cookie.setCookie("Bounced", utils.dateToISOString(new Date()), 0.5 / 24);
    document.body.appendChild(frame);
  };
  awa._registerSchemas = function (schemas) {
    /// <summary>
    /// Registers the specified schemas with the library.  An event can only be sent if a schema matching
    /// the event has been registered as the schema is used to validate and translate the event.
    /// </summary>
    /// <param name="schemas" type="Array">The schemas to register</param>
    for (var i = 0; i < schemas.length; i++) {
      awa._schemas[schemas[i].name] = schemas[i];
    }
  };
  awa.console = window.console || {};
  awa.console.fallback = awa.console.log || function () {};
  var logTypes = ["log", "info", "warn", "error", "trace"];
  for (var i = 0; i < logTypes.length; i++) {
    var m = logTypes[i];
    if (!awa.console[m]) {
      awa.console[m] = awa.console.fallback;
    }
  }
  function isOldIEBrowser() {
    var newerBrowserVersion = 9;
    var ua = utils.getUserAgent();
    var msie = ua.indexOf("MSIE ");
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10) < newerBrowserVersion;
    }
    return false;
  }
  awa.extendCoreData = function (data) {
    /// <summary> Extends core data for SPA with valid key/value pairs from data </summary>
    /// <param type="object">contains coreData key/value </param>
    utils.removeInvalidElements(data);
    config.coreData = utils.extend(true, config.coreData, data); // deep for pageTags object
  };
  awa._validateAndTranslateEvent = function (eventObject) {
    /// <summary> Jsll event viewer attaches to this method and reads the return value </summary>
    /// <param type="object"> Jsll event that is sent to Vortex </param>
    /// <return type="object"> Jsll event in an object under the event field </param>
    return { event: eventObject };
  };
  ///#DEBUG
  awa.testHook = {
    JSLL_VERSION: JSLL_VERSION,
    defaultConfig: function () {
      return config;
    },
    setAllowedGetLength: function (len) {
      allowedGetLength = len;
    },
    testUsePost: false,
    getAllowedGetLength: function () {
      return allowedGetLength;
    },
    getQueryFromJSON: getQueryFromJSON
  };
  ///#ENDDEBUG
})();
// -----------------------------------------------------------------------
//  <copyright file=asimovEventSchemas.ts company="Microsoft"
//      Copyright (c) Microsoft. All rights reserved.
//  </copyright>
//  <summary>
//      This is a auto-generated file using JSLLCodeGen (http://usnuget/packages/JSLLCodeGen/)
//  </summary>
// -----------------------------------------------------------------------
awa._registerSchemas([
  {
    name: "Ms.Cll.Javascript.CorsDisallowed",
    "Ms.Cll.Javascript.CorsDisallowed": {
      part: "C",
      def: {
        fields: [
          {
            req: true,
            name: "eventName",
            type: "string"
          },
          {
            name: "pageName",
            type: "string"
          },
          {
            name: "market",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "impressionGuid",
            type: "string"
          },
          {
            name: "serverImpressionGuid",
            type: "string"
          }
        ]
      }
    }
  },
  {
    name: "Ms.Cll.Javascript.EventTooLong",
    "Ms.Cll.Javascript.EventTooLong": {
      part: "C",
      def: {
        fields: [
          {
            req: true,
            name: "eventName",
            type: "string"
          },
          {
            req: true,
            name: "payloadLength",
            type: "int32"
          },
          {
            name: "pageName",
            type: "string"
          },
          {
            name: "market",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "impressionGuid",
            type: "string"
          },
          {
            name: "serverImpressionGuid",
            type: "string"
          }
        ]
      }
    }
  },
  {
    name: "Ms.Cll.Javascript.Error",
    "Ms.Telemetry.Error": {
      part: "B",
      def: {
        fields: [
          {
            name: "errorName",
            type: "string"
          },
          {
            name: "errorMessage",
            type: "string"
          },
          {
            name: "severity",
            type: "int32"
          },
          {
            name: "errorType",
            type: "string"
          },
          {
            name: "errorCode",
            type: "int32"
          },
          {
            name: "lineNumber",
            type: "uint32"
          },
          {
            name: "isDisplayed",
            type: "bool"
          },
          {
            name: "errorLocation",
            type: "string"
          },
          {
            name: "errorMethod",
            type: "string"
          }
        ]
      }
    },
    "Ms.Cll.Javascript.Error": {
      part: "C",
      def: {
        fields: [
          {
            req: true,
            name: "code",
            type: "int32"
          },
          {
            req: true,
            name: "message",
            type: "string"
          },
          {
            name: "pageName",
            type: "string"
          },
          {
            name: "market",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "impressionGuid",
            type: "string"
          },
          {
            name: "serverImpressionGuid",
            type: "string"
          }
        ]
      }
    }
  },
  {
    name: "Ms.Cll.Javascript.EventDropped",
    "Ms.Cll.Javascript.EventDropped": {
      part: "C",
      def: {
        fields: [
          {
            req: true,
            name: "eventName",
            type: "string"
          },
          {
            name: "pageName",
            type: "string"
          },
          {
            name: "market",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "impressionGuid",
            type: "string"
          },
          {
            name: "serverImpressionGuid",
            type: "string"
          },
          {
            name: "droppedInfo",
            type: "string"
          }
        ]
      }
    }
  },
  {
    name: "Ms.Webi.ClientError",
    "Ms.Webi.ClientError": {
      part: "B",
      def: {
        fields: [
          {
            req: true,
            name: "errorInfo",
            type: "string"
          },
          {
            name: "wasDisplayed",
            type: "bool"
          },
          {
            name: "impressionGuid",
            type: "string"
          },
          {
            name: "serverImpressionGuid",
            type: "string"
          },
          {
            name: "pageName",
            type: "string"
          },
          {
            name: "market",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "errorName",
            type: "string"
          },
          {
            name: "errorMessage",
            type: "string"
          },
          {
            name: "severity",
            type: "int32"
          },
          {
            name: "errorType",
            type: "string"
          },
          {
            name: "errorCode",
            type: "int32"
          },
          {
            name: "lineNumber",
            type: "uint32"
          },
          {
            name: "isDisplayed",
            type: "bool"
          },
          {
            name: "errorLocation",
            type: "string"
          },
          {
            name: "errorMethod",
            type: "string"
          }
        ]
      }
    }
  },
  {
    name: "Ms.Webi.OutgoingRequest",
    "Ms.Qos.OutgoingServiceRequest": {
      part: "B",
      def: {
        fields: [
          {
            req: true,
            name: "operationName",
            type: "string"
          },
          {
            name: "targetUri",
            type: "string"
          },
          {
            req: true,
            name: "latencyMs",
            type: "int32"
          },
          {
            name: "serviceErrorCode",
            type: "int32"
          },
          {
            req: true,
            name: "succeeded",
            type: "bool"
          },
          {
            name: "requestMethod",
            type: "string"
          },
          {
            name: "responseContentType",
            type: "string"
          },
          {
            name: "protocol",
            type: "string"
          },
          {
            name: "protocolStatusCode",
            type: "string"
          },
          {
            req: true,
            name: "dependencyOperationName",
            type: "string"
          },
          {
            name: "dependencyOperationVersion",
            type: "string"
          },
          {
            req: true,
            name: "dependencyName",
            type: "string"
          },
          {
            name: "dependencyType",
            type: "string"
          },
          {
            name: "responseSizeBytes",
            type: "int32"
          },
          {
            name: "requestStatus",
            type: "int32"
          }
        ]
      }
    },
    "Ms.Webi.OutgoingRequest": {
      part: "C",
      def: {
        fields: [
          {
            name: "impressionGuid",
            type: "string"
          },
          {
            name: "message",
            type: "string"
          },
          {
            name: "retryCount",
            type: "int32"
          },
          {
            name: "customData",
            type: "string"
          },
          {
            name: "serverImpressionGuid",
            type: "string"
          },
          {
            name: "pageName",
            type: "string"
          },
          {
            name: "market",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          }
        ]
      }
    }
  },
  {
    name: "Ms.Webi.PageView",
    "Ms.Content.PageView": {
      part: "B",
      def: {
        fields: [
          {
            name: "ver",
            type: "string"
          },
          {
            req: true,
            name: "impressionGuid",
            type: "string"
          },
          {
            req: true,
            name: "pageName",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "referrerUri",
            type: "string"
          },
          {
            name: "pageType",
            type: "string"
          },
          {
            name: "pageTags",
            type: "string"
          },
          {
            name: "product",
            type: "string"
          },
          {
            name: "screenState",
            type: "int32"
          },
          {
            name: "actionType",
            type: "string"
          },
          {
            name: "behavior",
            type: "int32"
          },
          {
            name: "resHeight",
            type: "int32"
          },
          {
            name: "resWidth",
            type: "int32"
          },
          {
            name: "vpHeight",
            type: "int32"
          },
          {
            name: "vpWidth",
            type: "int32"
          },
          {
            name: "market",
            type: "string"
          }
        ]
      }
    },
    "Ms.Webi.PageView": {
      part: "C",
      def: {
        fields: [
          {
            name: "cookieEnabled",
            type: "bool"
          },
          {
            name: "flashInstalled",
            type: "bool"
          },
          {
            name: "flashVersion",
            type: "string"
          },
          {
            name: "cookies",
            type: "string"
          },
          {
            name: "isJs",
            type: "bool"
          },
          {
            name: "title",
            type: "string"
          },
          {
            name: "isLoggedIn",
            type: "bool"
          },
          {
            name: "isManual",
            type: "bool"
          },
          {
            name: "serverImpressionGuid",
            type: "string"
          }
        ]
      }
    }
  },
  {
    name: "Ms.Webi.ContentUpdate",
    "Ms.Content.ContentUpdate": {
      part: "B",
      def: {
        fields: [
          {
            name: "ver",
            type: "string"
          },
          {
            req: true,
            name: "impressionGuid",
            type: "string"
          },
          {
            req: true,
            name: "pageName",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "pageTags",
            type: "string"
          },
          {
            name: "pageHeight",
            type: "int32"
          },
          {
            name: "vpHeight",
            type: "int32"
          },
          {
            name: "vpWidth",
            type: "int32"
          },
          {
            name: "market",
            type: "string"
          },
          {
            name: "actionType",
            type: "string"
          },
          {
            name: "behavior",
            type: "int32"
          },
          {
            name: "vScrollOffset",
            type: "int32"
          },
          {
            name: "hScrollOffset",
            type: "int32"
          },
          {
            name: "contentVer",
            type: "string"
          },
          {
            req: true,
            name: "content",
            type: "string"
          }
        ]
      }
    },
    "Ms.Webi.ContentUpdate": {
      part: "C",
      def: {
        fields: [
          {
            name: "pageLoadTime",
            type: "int32"
          },
          {
            name: "title",
            type: "string"
          },
          {
            name: "isJs",
            type: "bool"
          },
          {
            name: "cookieEnabled",
            type: "bool"
          },
          {
            name: "isLoggedIn",
            type: "bool"
          },
          {
            name: "isManual",
            type: "bool"
          },
          {
            name: "isDomComplete",
            type: "bool"
          },
          {
            name: "serverImpressionGuid",
            type: "string"
          },
          {
            name: "timings",
            type: "string"
          }
        ]
      }
    }
  },
  {
    name: "Ms.Webi.PageAction",
    "Ms.Content.PageAction": {
      part: "B",
      def: {
        fields: [
          {
            name: "ver",
            type: "string"
          },
          {
            req: true,
            name: "impressionGuid",
            type: "string"
          },
          {
            req: true,
            name: "pageName",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "destUri",
            type: "string"
          },
          {
            name: "market",
            type: "string"
          },
          {
            name: "pageType",
            type: "string"
          },
          {
            name: "pageTags",
            type: "string"
          },
          {
            name: "product",
            type: "string"
          },
          {
            name: "screenState",
            type: "int32"
          },
          {
            name: "actionType",
            type: "string"
          },
          {
            name: "behavior",
            type: "int32"
          },
          {
            name: "contentVer",
            type: "string"
          },
          {
            name: "content",
            type: "string"
          }
        ]
      }
    },
    "Ms.Webi.PageAction": {
      part: "C",
      def: {
        fields: [
          {
            name: "timeToAction",
            type: "int32"
          },
          {
            name: "cookieEnabled",
            type: "bool"
          },
          {
            name: "cookies",
            type: "string"
          },
          {
            name: "isJs",
            type: "bool"
          },
          {
            name: "title",
            type: "string"
          },
          {
            name: "referrerUri",
            type: "string"
          },
          {
            name: "isLoggedIn",
            type: "bool"
          },
          {
            name: "isManual",
            type: "bool"
          },
          {
            name: "serverImpressionGuid",
            type: "string"
          }
        ]
      }
    }
  },
  {
    name: "Ms.Webi.PageUnload",
    "Ms.Content.PageUnload": {
      part: "B",
      def: {
        fields: [
          {
            name: "ver",
            type: "string"
          },
          {
            req: true,
            name: "impressionGuid",
            type: "string"
          },
          {
            req: true,
            name: "pageName",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          }
        ]
      }
    },
    "Ms.Webi.PageUnload": {
      part: "C",
      def: {
        fields: [
          {
            name: "dwellTime",
            type: "int32"
          },
          {
            name: "scrollDepth",
            type: "string"
          },
          {
            name: "serverImpressionGuid",
            type: "string"
          },
          {
            name: "timings",
            type: "string"
          },
          {
            name: "vScrollOffset",
            type: "int32"
          },
          {
            name: "pageHeight",
            type: "int32"
          },
          {
            name: "vpHeight",
            type: "int32"
          },
          {
            name: "pageLoadTime",
            type: "int32"
          }
        ]
      }
    }
  }
]);
/*
// Examples of how to instantiate and use the custom events

//  Create an event of type: Ms.Cll.Javascript.CorsDisallowed
var event =
    {
        "name": "Ms.Cll.Javascript.CorsDisallowed",
        "data":
        {
            "Ms.Cll.Javascript.CorsDisallowed":
            {
                // Part C
                "eventName": "string", // string
                "pageName": "string", // optional string
                "market": "string", // optional string
                "uri": "string", // optional string
                "impressionGuid": "string", // optional string
                "serverImpressionGuid": "string" // optional string
            }
        }
    };


//  Create an event of type: Ms.Cll.Javascript.EventTooLong
var event =
    {
        "name": "Ms.Cll.Javascript.EventTooLong",
        "data":
        {
            "Ms.Cll.Javascript.EventTooLong":
            {
                // Part C
                "eventName": "string", // string
                "payloadLength": 0, // int32
                "pageName": "string", // optional string
                "market": "string", // optional string
                "uri": "string", // optional string
                "impressionGuid": "string", // optional string
                "serverImpressionGuid": "string" // optional string
            }
        }
    };


//  Create an event of type: Ms.Cll.Javascript.Error
var event =
    {
        "name": "Ms.Cll.Javascript.Error",
        "data":
        {
            "Ms.Telemetry.Error":
            {
                // Part B
                "errorName": "string", // optional string
                "errorMessage": "string", // optional string
                "severity": 0, // optional int32
                "errorType": "string", // optional string
                "errorCode": 0, // optional int32
                "lineNumber": 0, // optional uint32
                "isDisplayed": true, // optional bool
                "errorLocation": "string", // optional string
                "errorMethod": "string" // optional string
            },
            "Ms.Cll.Javascript.Error":
            {
                // Part C
                "code": 0, // int32
                "message": "string", // string
                "pageName": "string", // optional string
                "market": "string", // optional string
                "uri": "string", // optional string
                "impressionGuid": "string", // optional string
                "serverImpressionGuid": "string" // optional string
            }
        }
    };


//  Create an event of type: Ms.Cll.Javascript.EventDropped
var event =
    {
        "name": "Ms.Cll.Javascript.EventDropped",
        "data":
        {
            "Ms.Cll.Javascript.EventDropped":
            {
                // Part C
                "eventName": "string", // string
                "pageName": "string", // optional string
                "market": "string", // optional string
                "uri": "string", // optional string
                "impressionGuid": "string", // optional string
                "serverImpressionGuid": "string", // optional string
                "droppedInfo": "string" // optional string
            }
        }
    };


//  Create an event of type: Ms.Webi.ClientError
var event =
    {
        "name": "Ms.Webi.ClientError",
        "data":
        {
            "Ms.Webi.ClientError":
            {
                // Part B
                "errorInfo": "string", // string
                "wasDisplayed": true, // optional bool
                "impressionGuid": "string", // optional string
                "serverImpressionGuid": "string", // optional string
                "pageName": "string", // optional string
                "market": "string", // optional string
                "uri": "string", // optional string
                "errorName": "string", // optional string
                "errorMessage": "string", // optional string
                "severity": 0, // optional int32
                "errorType": "string", // optional string
                "errorCode": 0, // optional int32
                "lineNumber": 0, // optional uint32
                "isDisplayed": true, // optional bool
                "errorLocation": "string", // optional string
                "errorMethod": "string" // optional string
            }
        }
    };


//  Create an event of type: Ms.Webi.OutgoingRequest
var event =
    {
        "name": "Ms.Webi.OutgoingRequest",
        "data":
        {
            "Ms.Qos.OutgoingServiceRequest":
            {
                // Part B
                "operationName": "string", // string
                "targetUri": "string", // optional string
                "latencyMs": 0, // int32
                "serviceErrorCode": 0, // optional int32
                "succeeded": true, // bool
                "requestMethod": "string", // optional string
                "responseContentType": "string", // optional string
                "protocol": "string", // optional string
                "protocolStatusCode": "string", // optional string
                "dependencyOperationName": "string", // string
                "dependencyOperationVersion": "string", // optional string
                "dependencyName": "string", // string
                "dependencyType": "string", // optional string
                "responseSizeBytes": 0, // optional int32
                "requestStatus": 0 // optional int32
            },
            "Ms.Webi.OutgoingRequest":
            {
                // Part C
                "impressionGuid": "string", // optional string
                "message": "string", // optional string
                "retryCount": 0, // optional int32
                "customData": "string", // optional string
                "serverImpressionGuid": "string", // optional string
                "pageName": "string", // optional string
                "market": "string", // optional string
                "uri": "string" // optional string
            }
        }
    };


//  Create an event of type: Ms.Webi.PageView
var event =
    {
        "name": "Ms.Webi.PageView",
        "data":
        {
            "Ms.Content.PageView":
            {
                // Part B
                "ver": "string", // optional string
                "impressionGuid": "string", // string
                "pageName": "string", // string
                "uri": "string", // optional string
                "referrerUri": "string", // optional string
                "pageType": "string", // optional string
                "pageTags": "string", // optional string
                "product": "string", // optional string
                "screenState": 0, // optional int32
                "actionType": "string", // optional string
                "behavior": 0, // optional int32
                "resHeight": 0, // optional int32
                "resWidth": 0, // optional int32
                "vpHeight": 0, // optional int32
                "vpWidth": 0, // optional int32
                "market": "string" // optional string
            },
            "Ms.Webi.PageView":
            {
                // Part C
                "cookieEnabled": true, // optional bool
                "flashInstalled": true, // optional bool
                "flashVersion": "string", // optional string
                "cookies": "string", // optional string
                "isJs": true, // optional bool
                "title": "string", // optional string
                "isLoggedIn": true, // optional bool
                "isManual": true, // optional bool
                "serverImpressionGuid": "string" // optional string
            }
        }
    };


//  Create an event of type: Ms.Webi.ContentUpdate
var event =
    {
        "name": "Ms.Webi.ContentUpdate",
        "data":
        {
            "Ms.Content.ContentUpdate":
            {
                // Part B
                "ver": "string", // optional string
                "impressionGuid": "string", // string
                "pageName": "string", // string
                "uri": "string", // optional string
                "pageTags": "string", // optional string
                "pageHeight": 0, // optional int32
                "vpHeight": 0, // optional int32
                "vpWidth": 0, // optional int32
                "market": "string", // optional string
                "actionType": "string", // optional string
                "behavior": 0, // optional int32
                "vScrollOffset": 0, // optional int32
                "hScrollOffset": 0, // optional int32
                "contentVer": "string", // optional string
                "content": "string" // string
            },
            "Ms.Webi.ContentUpdate":
            {
                // Part C
                "pageLoadTime": 0, // optional int32
                "title": "string", // optional string
                "isJs": true, // optional bool
                "cookieEnabled": true, // optional bool
                "isLoggedIn": true, // optional bool
                "isManual": true, // optional bool
                "isDomComplete": true, // optional bool
                "serverImpressionGuid": "string", // optional string
                "timings": "string" // optional string
            }
        }
    };


//  Create an event of type: Ms.Webi.PageAction
var event =
    {
        "name": "Ms.Webi.PageAction",
        "data":
        {
            "Ms.Content.PageAction":
            {
                // Part B
                "ver": "string", // optional string
                "impressionGuid": "string", // string
                "pageName": "string", // string
                "uri": "string", // optional string
                "destUri": "string", // optional string
                "market": "string", // optional string
                "pageType": "string", // optional string
                "pageTags": "string", // optional string
                "product": "string", // optional string
                "screenState": 0, // optional int32
                "actionType": "string", // optional string
                "behavior": 0, // optional int32
                "contentVer": "string", // optional string
                "content": "string" // optional string
            },
            "Ms.Webi.PageAction":
            {
                // Part C
                "timeToAction": 0, // optional int32
                "cookieEnabled": true, // optional bool
                "cookies": "string", // optional string
                "isJs": true, // optional bool
                "title": "string", // optional string
                "referrerUri": "string", // optional string
                "isLoggedIn": true, // optional bool
                "isManual": true, // optional bool
                "serverImpressionGuid": "string" // optional string
            }
        }
    };


//  Create an event of type: Ms.Webi.PageUnload
var event =
    {
        "name": "Ms.Webi.PageUnload",
        "data":
        {
            "Ms.Content.PageUnload":
            {
                // Part B
                "ver": "string", // optional string
                "impressionGuid": "string", // string
                "pageName": "string", // string
                "uri": "string" // optional string
            },
            "Ms.Webi.PageUnload":
            {
                // Part C
                "dwellTime": 0, // optional int32
                "scrollDepth": "string", // optional string
                "serverImpressionGuid": "string", // optional string
                "timings": "string", // optional string
                "vScrollOffset": 0, // optional int32
                "pageHeight": 0, // optional int32
                "vpHeight": 0, // optional int32
                "pageLoadTime": 0 // optional int32
            }
        }
    };

*/
// -----------------------------------------------------------------------
//  <copyright file="eventValidation.js" company="Microsoft">
//      Copyright (c) Microsoft. All rights reserved.
//  </copyright>
//  <summary>
//      This module validates events
//  </summary>
// -----------------------------------------------------------------------
awa.isEventValid = function (event) {
  var logWarning = awa.logger.logWarning;
  function logAndSend(overrideValues, isDropped) {
    /// <summary> logs to console and calls awa.ct.captureEventDrop() </summary>
    var details = overrideValues.eventName + " - " + overrideValues.droppedInfo;
    if (isDropped) {
      logWarning("Dropped event " + details);
      // config cannot be read here, so autoCapture.invalidEvents is read in ct
      awa.ct.captureEventDrop(overrideValues);
    } else {
      logWarning("Dropped field from " + details);
    }
  }
  function isInArray(array, obj) {
    for (var i = 0; i < array.length; i++) {
      if (array[i] == obj) {
        return true;
      }
    }
    return false;
  }
  function validatePart(part, partSchema) {
    // check for extra fields
    var partFields = [];
    var schemaFields = [];
    var numberOfFields = partSchema.length;
    for (var fieldIndex = 0; fieldIndex < numberOfFields; fieldIndex++) {
      // validate individual fields
      var field = partSchema[fieldIndex];
      var fieldName = field.name;
      schemaFields.push(fieldName);
      var fieldType = field.type;
      var fieldValue = part[fieldName];
      var required = field.req;
      if (!awa.utils.isValueAssigned(fieldValue)) {
        if (required === true) {
          // drop event if required field is missing
          logAndSend({ eventName: eventName, droppedInfo: "Missing field: " + fieldName }, true);
          return false;
        }
      } else if (!awa.utils.isOfCorrectType(fieldType, fieldValue)) {
        logAndSend({ eventName: eventName, droppedInfo: "Incorrect type: " + fieldName }, required);
        if (required === true) {
          // drop event if wrong type for required field
          return false;
        } else {
          // delete field if wrong type and optional
          delete part[fieldName];
        }
      }
    }
    // validate extra fields in event
    var numberOfpartFieldsInEvent = partFields.length;
    for (var partField in part) {
      if (!(partField == "baseData" || partField == "baseType")) {
        if (!isInArray(schemaFields, partField)) {
          // delete extra fields
          logAndSend({ eventName: eventName, droppedInfo: "Unexpected field " + partField }, false);
          delete part[partField];
        }
      }
    }
    return true;
  }
  if (event) {
    var eventName = event.name;
    var schemas = awa._schemas;
    var partBName = event.data.baseType;
    var partCName = eventName;
    var thisEventSchema = schemas[eventName];
    if (thisEventSchema) {
      // validate part B
      if (partBName) {
        var partB = event.data.baseData;
        var partBSchema = thisEventSchema[partBName] ? thisEventSchema[partBName].def.fields : undefined;
        if (partB && partBSchema) {
          if (!validatePart(partB, partBSchema)) {
            return false;
          }
        }
      }
      // validate part C
      if (partCName) {
        var partC = event.data;
        var partCSchema = thisEventSchema[partCName] ? thisEventSchema[partCName].def.fields : undefined;
        if (partC && partCSchema) {
          if (!validatePart(partC, partCSchema)) {
            return false;
          }
        }
      }
    } else {
      // drop unregistered event
      logAndSend({ eventName: eventName, droppedInfo: "Not registered in JSLL" }, true);
      return false;
    }
    return true;
  } else {
    return false;
  }
};
awa.translateEventFromIntermediateStructure = function (oldEvent) {
  var eventName = oldEvent.name;
  var oldEventData = oldEvent.data;
  var utils = awa.utils;
  if (utils.isValueAssigned(oldEventData[eventName])) {
    var oldPartC = utils.extend(true, oldEventData[eventName]);
    delete oldEventData[eventName];
    var keysInData = [];
    for (var key in oldEventData) {
      keysInData.push(key);
    }
    var oldPartB = utils.extend(true, oldEventData[keysInData[0]]);
    delete oldEventData[keysInData[0]];
    delete oldEvent.content;
    var data = utils.extend(true, JSON.stringify(oldPartB) !== "{}" ? { baseData: oldPartB } : {}, oldPartC, {
      baseType: keysInData[0]
    });
    var returnObject = utils.extend(true, oldEvent, { data: data });
    return returnObject;
  } else {
    return oldEvent;
  }
};
// -----------------------------------------------------------------------
//  <copyright file="ix.ts" company="Microsoft">
//      Copyright (c) Microsoft. All rights reserved.
//  </copyright>
//  <summary>
//      This module handles JSLLs response to mc1 and anid from Vortex,
//      including id swaps
//  </summary>
// -----------------------------------------------------------------------
awa.ix = (function () {
  var configIx = {};
  var mc1 = "";
  var anid = "";
  var isAssigned = awa.utils.isValueAssigned;
  function init(config) {
    /// <summary> pass in config object </summary>
    configIx = config.ix;
  }
  function getAdobeUrl() {
    /// <summary> This method returns the URL for the Adobe ID swap </summary>
    /// <returns type="string"> adobe url </returns>
    var mc1IdKey = "88170%01";
    var anidKey = "88169%01";
    var qpSeparation = "%01";
    var versionAndSuffix = "&d_ver=2";
    var authStatus = "%010";
    if (isAssigned(mc1) || isAssigned(anid)) {
      return (
        "https://dpm.demdex.net/id?d_orgid=A5FF776A5245AF830A490D44@AdobeOrg&d_cid=" +
        (isAssigned(mc1) ? mc1IdKey + mc1 + authStatus : "") +
        (isAssigned(anid) ? (isAssigned(mc1) ? qpSeparation : "") + anidKey + anid + authStatus : "") +
        versionAndSuffix
      );
    } else {
      return undefined;
    }
  }
  function getGoogleUrl() {
    /// <summary> This method returns the URL for the Adobe ID swap </summary>
    /// <returns type="string"> google url </returns>
    if (isAssigned(mc1)) {
      return (
        "https://ad.doubleclick.net/ddm/activity/src=6952136;type=store0;cat=jsll;u58=" +
        mc1 +
        ";dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;ord=1?"
      );
    }
    return undefined;
  }
  function receiveIdsFromVortex(ids) {
    /// <summary> Called by Vortex t.js request, sets mc1 and anid </summary>
    /// <params type="object"> JSON object containing mc1 and/or anid </returns>
    if (ids) {
      mc1 = ids.mc1;
      anid = ids.anid;
      // check that at least one is assigned
      if (isAssigned(mc1) || isAssigned(anid)) {
        if (configIx.a) {
          // make Adobe ID swap through GET and awa.ct.captureSwap callback
          var request = new XMLHttpRequest();
          request.onreadystatechange = function () {
            if (request.readyState == 4 && request.status == 200) {
              // send Id back to Vortex
              awa.ct.captureSwap(JSON.parse(request.responseText));
            }
          };
          var requestSrc = getAdobeUrl();
          if (isAssigned(requestSrc)) {
            request.open("GET", requestSrc, true);
            request.setRequestHeader("Accept", "application/json; charset=utf-8");
            request.send();
          }
        }
        if (configIx.g) {
          var requestSrc = getGoogleUrl();
          if (isAssigned(requestSrc)) {
            var newImage = new Image();
            newImage.src = requestSrc;
          }
        }
      }
    }
  }
  return {
    init: init,
    set: receiveIdsFromVortex,
    testHook: {
      getAdobeUrl: getAdobeUrl,
      getGoogleUrl: getGoogleUrl,
      setMc1: function (newMc1) {
        mc1 = newMc1;
      },
      setAnid: function (newAnid) {
        anid = newAnid;
      }
    }
  };
})();
// -----------------------------------------------------------------------
//  <copyright file="clickstreamTracker.ts" company="Microsoft">
//      Copyright (c) Microsoft. All rights reserved.
//  </copyright>
//  <summary>
//      This module contains the default instrumentation for PageView, PageAction &PageLoadTime data capture.
//      This captures click events for the following html elements/controls A, IMG, AREA, INPUT by default.
//  </summary>
// -----------------------------------------------------------------------
awa.ct = (function () {
  var MSCONTENT_PARTB_VERSION = "1.0";
  var CONTENT_VERSION = "2.0";
  var MAX_CONTENTNAME_LENGTH = 200;
  var IS_SENSITIVE_FLAG = 0x080000;
  var config = {};
  var autoCapture = {};
  var cookie = awa.cookie;
  var errorHandler = awa.errorHandler;
  var ids = awa.ids;
  var vortexEvents = awa.vortexEvents;
  var utils = awa.utils;
  var actionTypeEnum = awa.actionType;
  var maxScroll = { h: 0, v: 0 };
  var doNotTrackFieldName = "data-bi-dnt";
  var manualTrackingOnlyFieldName = "data-bi-mto";
  var isPageUnloadFired = false;
  var contentBlobFieldNameObjects = {
    longNames: {
      isShortNames: false,
      id: "data-bi-id",
      areaName: "data-bi-area",
      slotNumber: "data-bi-slot",
      contentName: "data-bi-name",
      contentSource: "data-bi-source",
      templateName: "data-bi-view",
      productId: "data-bi-product",
      contentType: "data-bi-type"
    },
    shortNames: {
      isShortNames: true,
      id: "data-bi-id",
      areaName: "data-bi-an",
      slotNumber: "data-bi-sn",
      contentName: "data-bi-cn",
      contentSource: "data-bi-cs",
      templateName: "data-bi-tn",
      productId: "data-bi-pid",
      contentType: "data-bi-ct"
    }
  };
  // These are legacy names for tagging content metadata.  This is our default until all adopters have moved to new short content names.
  var contentBlobFieldNames = contentBlobFieldNameObjects.longNames;
  var clickCaptureInputTypes = { BUTTON: true, CHECKBOX: true, RADIO: true, RESET: true, SUBMIT: true };
  /// <summary>
  ///  Initializes JSLL (automatic tracking of events), sets up various settings and variables used by JSLL.
  /// </summary>
  /// <param name="inputConfig">configuration object.</param>
  function init(inputConfig) {
    if (!awa.isAvailable) {
      return;
    }
    config = inputConfig;
    autoCapture = config.autoCapture;
    contentBlobFieldNames =
      config.useShortNameForContentBlob === true
        ? contentBlobFieldNameObjects.shortNames
        : contentBlobFieldNameObjects.longNames;
    // Note: PageView is sent as soon as init is called (i.e. right after the JSLL script is loaded).
    // No Muid Sync will happen as we wait to send PV as soon as possible while Muid Sync requires document ready to happen.
    // This matches WEDCS in way of when they send PV without Muid Sync.
    if (autoCapture.pageView) {
      sendPageView({ isAuto: true });
    }
    // handle automatic event firing on user click
    if (autoCapture.click) {
      if (window.addEventListener) {
        // IE9 onwards addEventListener is available, "click" event captures mouse click. mousedown works on other browsers
        var event = navigator.appVersion.indexOf("MSIE") !== -1 ? "click" : "mousedown";
        window.addEventListener(event, processClick, false);
        window.addEventListener("keyup", processClick, false);
      } else if (document.attachEvent) {
        // IE8 and below doesn't have addEventListener so it will use attachEvent
        // attaching to window does not work in IE8
        document.attachEvent("onclick", processClick);
        document.attachEvent("keyup", processClick);
      }
    }
    if (autoCapture.jsError) {
      errorHandler.init();
    }
    // handle automatic event firing on user scroll
    if (autoCapture.scroll) {
      var processScroll = debounce(
        // on first call do nothing
        null,
        // after debounce, send contentView with viewportOffset
        function () {
          sendContentUpdate({ isAuto: true, actionType: awa.actionType.SCROLL });
        },
        config.debounceMs.scroll
      );
      if (window.addEventListener) {
        window.addEventListener("scroll", processScroll);
      } else if (window.attachEvent) {
        window.attachEvent("onscroll", processScroll);
      }
    }
    // handle automatic event firing on user resize
    if (autoCapture.resize) {
      /// I wasn’t able to repro the bug
      /// (https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/7958464)
      /// until new content was loaded on the page and the resize
      /// rendering became slow. When resize happens, the page rendering
      /// time is longer than the resize debounce, and resize render
      /// happens in time > debounce, and so resize is acting like
      /// it's being done twice: once at the beginning of user resize,
      /// one at the end of browser render resize.
      var processResize = debounce(
        // on first call, send resize contentUpdate
        function () {
          sendContentUpdate({ isAuto: true, actionType: awa.actionType.RESIZE });
        },
        // after debounce, do nothing
        null,
        config.debounceMs.resize
      );
      if (window.addEventListener) {
        window.addEventListener("resize", processResize);
      } else if (window.attachEvent) {
        window.attachEvent("onresize", processResize);
      }
    }
    // measure maxScroll
    if (autoCapture.onUnload || config.manualPageUnload) {
      var getMaxScrollDepth = function () {
        var currentScroll = getScrollOffset();
        maxScroll.v = maxScroll.v > currentScroll.v ? maxScroll.v : currentScroll.v;
      };
      if (window.addEventListener) {
        window.addEventListener("scroll", getMaxScrollDepth);
      } else if (window.attachEvent) {
        window.attachEvent("onscroll", getMaxScrollDepth);
      }
    }
    if (autoCapture.onUnload) {
      if (window.addEventListener) {
        window.addEventListener("beforeunload", sendPageUnload);
        window.addEventListener("unload", sendPageUnload);
      } else if (window.attachEvent) {
        window.attachEvent("onbeforeunload", sendPageUnload);
        window.attachEvent("onunload", sendPageUnload);
      }
    }
    if (config.sendMode == 2) {
      // send batched events before closing the page
      var sendBatched = awa.vortexEvents.batchQueuedEvents;
      if (window.addEventListener) {
        window.addEventListener("beforeunload", sendBatched);
        window.addEventListener("unload", sendBatched);
      } else if (window.attachEvent) {
        window.attachEvent("onbeforeunload", sendBatched);
        window.attachEvent("onunload", sendBatched);
      }
    }
    if (config.authMethod == 2 && config.shareAuthStatus == true && config.isLoggedIn == true) {
      if (window.addEventListener) {
        window.addEventListener("message", receiveMessage);
      } else if (window.attachEvent) {
        window.attachEvent("onmessage", receiveMessage);
      }
    }
    if (config.syncMuid || config.autoCapture.onLoad) {
      onDomReadyDo(awa.ct.domReadyTasksWrapper);
    }
  }
  /// <summary>
  /// attaches to message to receive responses from Vortex.
  /// || login.microsoftonline.com is workaround for IE10 where the origin is the iframe of origin not
  /// origin of request
  /// </summary>
  function receiveMessage(event) {
    if (
      event.origin == "https://web.vortex.data.microsoft.com" ||
      event.origin == "https://login.microsoftonline.com"
    ) {
      if (event.data) {
        try {
          var dataObject = JSON.parse(event.data);
          if (dataObject && dataObject.Action == "firstEventDone") {
            awa.firstEventDone();
          }
          if (dataObject && dataObject.BouncedCookieExpires) {
            var cookieValue =
              "Bounced=" +
              utils.dateToISOString(new Date()) +
              "; expires=" +
              new Date(dataObject.BouncedCookieExpires).toUTCString() +
              "; path=/;";
            window.document.cookie = cookieValue;
          }
        } catch (e) {}
      }
    }
  }
  // use smallest domready ever for IE8. When IE8 is deprecated, use addEventListener("DomContentLoaded")
  function onDomReadyDo(f) {
    /// <summary> fires function f on domRead </summary>
    /// <param type="function">function to call on domRead</param>
    /in/.test(document.readyState)
      ? setTimeout(function () {
          awa.ct.onDomReadyDo(f);
        }, 100)
      : f.call();
  }
  function domReadyTasks() {
    if (config.syncMuid) {
      syncupMuid();
    }
    if (autoCapture.onLoad) {
      if (document.readyState === "complete") {
        sendAutoContentUpdate();
      } else {
        if (window.addEventListener) {
          window.addEventListener("load", sendAutoContentUpdate); // NB **not** "onload"
        } else if (window.attachEvent) {
          window.attachEvent("onload", sendAutoContentUpdate); // IE8
        }
      }
    }
  }
  function domReadyTasksWrapper() {
    awa.ct.domReadyTasks();
  }
  function getPageName() {
    /// <summary>
    ///  Gets the pageName from the DOM or by calling a override if set.
    /// </summary>
    if (config.callback && typeof config.callback.pageName === "function") {
      return config.callback.pageName();
    } else if (config.coreData.pageName) {
      return config.coreData.pageName;
    } else {
      var pagename = window.location.pathname;
      var framents = pagename.split("/");
      if (framents.length > 2 && framents[2] !== "") {
        pagename = framents[2];
      } else {
        pagename = "Home";
      }
      return pagename;
    }
  }
  function getTitle() {
    /// <summary> Returns the first 150 characters of the title or override if set..  This is
    /// to keep from exteremely long titles are not collected, that are essentially useless for BI < /summary>
    if (config.coreData.title) {
      return config.coreData.title;
    } else {
      return document.title.substring(0, 150);
    }
  }
  function syncupMuid() {
    /// <summary>
    ///  Creates an image tab to the muid sync endpoint for the given muidDomain.
    ///  The image fetch brings down a muid cookie.
    /// </summary>
    var muidHost = utils.getMuidHost(config.muidDomain || "microsoft.com");
    if (muidHost) {
      var muidsrc = (window.location.protocol || "http:") + "//" + muidHost + "/c.gif?DI=4050&did=1&t=";
      var img = document.createElement("IMG");
      img.style.display = "none";
      img.src = muidsrc;
      img.hidden = "";
      img["aria-hidden"] = "true";
      img.role = "presentation";
    } else {
      awa.logger.logWarning(
        "Unable to get a muid host for the configured muidDomain '" + config.muidDomain + "'.  Unable to sync muid"
      );
    }
  }
  function isRightClick(evt) {
    /// <summary> Determines whether an event is a right click or not </summary>
    /// <param type="object"> the event </param>
    /// <returns> true if the event is a right click </returns>
    if (evt.which) {
      return evt.which === 3;
    } else if (evt.button) {
      return evt.button === 2;
    }
  }
  function isLeftClick(evt) {
    /// <summary> Determines whether an event is a left click or not </summary>
    /// <param type="object"> the event </param>
    /// <returns> true if the event is a left click </returns>
    if (evt.which) {
      return evt.which === 1;
    } else if (evt.button) {
      return evt.button === 1;
    }
  }
  function isMiddleClick(evt) {
    /// <summary> Determines whether an event is a middle click or not </summary>
    /// <param type="object"> the event </param>
    /// <returns> true if the event is a middle click </returns>
    if (evt.which) {
      return evt.which === 2;
    } else if (evt.button) {
      return evt.button === 4;
    }
  }
  function isKeyboardEnter(evt) {
    /// <summary> Determines whether an event is a keyboard enter or not </summary>
    /// <param type="object"> the event </param>
    /// <returns> true if the event is a keyboard enter </returns>
    if (evt.keyCode) {
      return evt.keyCode === 13;
    }
  }
  function isKeyboardSpace(evt) {
    /// <summary> Determines whether an event is a keyboard space or not </summary>
    /// <param type="object"> the event </param>
    /// <returns> true if the event is a keyboard space </returns>
    if (evt.keyCode) {
      return evt.keyCode === 32;
    }
  }
  function processClick(event) {
    var clickCaptureElements = { A: true, BUTTON: true, AREA: true, INPUT: true };
    var evt = event || window.event; // IE 8 does not pass the event
    var e = evt.srcElement || evt.target;
    // populate overrideValues
    var overrideValues = { isAuto: true };
    if (isRightClick(evt)) {
      overrideValues.actionType = actionTypeEnum.CLICKRIGHT;
      // Look if element is decorated with data-bi-bhvr tag, do not override if it is
      var element = utils.findClosestByAttribute(e, "data-bi-bhvr");
      if (!utils.isValueAssigned(element)) {
        overrideValues.behavior = awa.behavior.CONTEXTMENU;
      }
    } else if (isLeftClick(evt)) {
      overrideValues.actionType = actionTypeEnum.CLICKLEFT;
    } else if (isKeyboardEnter(evt)) {
      overrideValues.actionType = actionTypeEnum.KEYBOARDENTER;
    } else if (isKeyboardSpace(evt)) {
      overrideValues.actionType = actionTypeEnum.KEYBOARDSPACE;
    } else if (isMiddleClick(evt)) {
      overrideValues.actionType = actionTypeEnum.CLICKMIDDLE;
    } else {
      return;
    }
    while (e && e.tagName) {
      if (!clickCaptureElements[e.tagName.toUpperCase()]) {
        e = e.parentElement || e.parentNode;
        continue;
      } else {
        // Check allowed INPUT types
        var sendEvent = e.tagName.toUpperCase() === "INPUT" ? clickCaptureInputTypes[e.type.toUpperCase()] : true;
        if (sendEvent) {
          //Check for data-bi-mto tag (Manual tracking only)
          if (!isTagFoundInElement(e, manualTrackingOnlyFieldName)) {
            sendClickEvent(e, overrideValues);
          }
        }
        break;
      }
    }
  }
  function isTagFoundInElement(element, tag) {
    var taggedElement = utils.findClosestByAttribute(element, tag);
    if (!utils.isValueAssigned(taggedElement)) {
      return false;
    }
    return true;
  }
  function debounce(firstCallFunction, secondCallFunction, wait) {
    /// <summary>  When constantly called, debounce returns two functions, where
    /// - function 1 will trigger at first call,
    /// - function 2 will be called at last call, after it stops being called for
    /// 'wait' milliseconds
    /// </summary>
    /// <param name="firstCallFunction"> The function that will trigger at first call </param>
    /// <param name="lastCallFunction"> The function that will trigger at last call after 'wait' milliseconds </param>
    /// <param name="wait"> The debounce time interval </param>
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (secondCallFunction) {
          secondCallFunction.apply(context, args);
        }
      };
      var callNow = !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) {
        if (firstCallFunction) {
          firstCallFunction.apply(context, args);
        }
      }
    };
  }
  function sendPageView(overrideValues) {
    /// <summary> This method collects PageView schema data and sends event.</summary>
    /// <param name="overrideValues">
    ///  Override object that allows adopters to override the default collection behavior of AWA
    ///  The schema for the overrideValues object is:
    ///  {
    ///     "isAuto": true,
    ///     "behavior": 2,
    ///     "uri":"http://customuri",
    ///     "referrerUri": "http://bing.com?q=windowsstore",
    ///     "pageName": "mypagename",
    ///     "actionType": "CL",
    ///     "pageHeight": 1234,
    ///     "pageTags":
    ///     {
    ///         "metaTags":{
    ///                     "meta1": "value1", "meta2":"value2"
    ///                    },
    ///         "custom1":"customvalue1",
    ///         "custom2":"customvalue2"
    ///     }
    ///  }
    /// </param>
    /// <remarks>Order of precedence: 1)overrideValues parameter 2)metadata from DOM/Browser </remarks>
    resetPageUnloadProperties();
    overrideValues = overrideValues || {};
    var allCookies = cookie.getAllCookies();
    // Collect data from meta tags.  most of the values to into the pageTags.metaTags property.  A few go to specific top level fields.
    var eventData = {};
    var pageTags = awa.utils.extend(true, config.coreData.pageTags);
    pageTags.metaTags = collectMetaTagsAndSetEventProperty(eventData, true);
    setEnabledFeatures(pageTags, allCookies);
    if (typeof config.callback.pageViewPageTags === "function") {
      pageTags = utils.extend(true, pageTags, config.callback.pageViewPageTags());
    }
    var screenRes = getScreenResolution();
    // Make the event
    var pageViewEvent = {
      name: "Ms.Webi.PageView",
      data: {
        baseData: {
          ver: MSCONTENT_PARTB_VERSION,
          impressionGuid: ids.getPageViewImpressionGuid(),
          pageName: overrideValues.pageName || getPageName(),
          uri: overrideValues.uri || getCurrentUri(),
          referrerUri: overrideValues.referrerUri || config.coreData.referrerUri,
          market: eventData.market,
          pageType: eventData.pageType,
          product: eventData.product,
          resHeight: screenRes.h,
          resWidth: screenRes.w,
          pageTags: JSON.stringify(utils.extend(true, pageTags, overrideValues.pageTags)),
          actionType: overrideValues.actionType || eventData.actionType,
          behavior:
            getValidBehavior(overrideValues.behavior) ||
            (eventData.behavior ? eventData.behavior : awa.behavior.UNDEFINED)
        },
        baseType: "Ms.Content.PageView",
        cookieEnabled: getCookieEnabled(),
        cookies: getClientCookies(allCookies),
        isJs: true,
        title: overrideValues.title || getTitle(),
        isLoggedIn: config.isLoggedIn,
        serverImpressionGuid: eventData.serverImpressionGuid,
        isManual: true // default value.  Will be overridden below if needed.
      },
      flags: eventData.isSensitive ? IS_SENSITIVE_FLAG : undefined
    };
    if (config.autoCapture.addin) {
      var flashInfo = getFlashInfo();
      pageViewEvent.data.flashInstalled = flashInfo["installed"] || false;
      pageViewEvent.data.flashVersion = flashInfo["version"] || "";
    }
    sendEventAfterOverridesAndStringify(pageViewEvent, overrideValues, eventData.env, true);
  }
  function sendAutoContentUpdate() {
    /// <summary> This method attaches to the DomComplete event and fires
    /// a contentView event with
    /// - isAuto set to true
    /// - domComplete set to true to differentiate DomComplete content views from others,
    /// </summary>
    sendContentUpdate({ isAuto: true, isDomComplete: true });
  }
  function sendContentUpdate(overrideValues) {
    /// <summary> This method collects ContentUpdate schema data and sends event. </summary>
    /// <param name="overrideValues">
    ///  Override object that allows adopters to override the default collection behavior of AWA
    ///  The schema for the overrideValues object is:
    ///  {
    ///     "isAuto": true,
    ///     "behavior": 41,
    ///     "uri":"http://customuri",
    ///     "referrerUri": "http://bing.com?q=windowsstore",
    ///     "pageName": "mypagename",
    ///     "actionType": "CL",
    ///     "pageHeight": 1234,
    ///     "content": "mycontentvalue.  Entire content collected will be stomped by this.",
    ///     "contentTags": {},  // This will be "added" to the content collected by default population.
    ///     "vScrollOffset": 100,
    ///     "hScrollOffset": 20,
    ///     "isDomComplete": true,
    ///     "pageLoadTime":123,
    ///     "pageTags":
    ///     {
    ///         "metaTags":{
    ///                     "meta1": "value1", "meta2":"value2"
    ///                    },
    ///         "custom1":"customvalue1",
    ///         "custom2":"customvalue2"
    ///     }
    ///  }
    /// </param>
    /// <remarks>Order of precedence: 1)overrideValues parameter 2)metadata from DOM/Browser </remarks>
    overrideValues = overrideValues || {};
    // Collect data from meta tags.  most of the values to into the pageTags.metaTags property.  A few go to specific top level fields.
    var eventData = {};
    var pageTags = awa.utils.extend(true, config.coreData.pageTags);
    pageTags.metaTags = collectMetaTagsAndSetEventProperty(eventData);
    var allCookies = cookie.getAllCookies();
    setEnabledFeatures(pageTags, allCookies);
    // Collect Performance and Timing data in to pageTags.
    if (overrideValues && overrideValues.isDomComplete) {
      if (autoCapture.perf === true) {
        if (window.performance) {
          if (window.performance.timing) {
            pageTags.timing = utils.stringifyField("timing", window.performance.timing);
          }
          if (autoCapture.assets === true) {
            var perfData = utils.getPerformanceData();
            if (perfData) {
              pageTags.AssetPerformance = utils.stringifyField("AssetPerformance", perfData);
            }
          }
        }
      }
    }
    if (typeof config.callback.contentUpdatePageTags === "function") {
      pageTags = utils.extend(true, pageTags, config.callback.contentUpdatePageTags());
    }
    var viewportDim = getViewportDimensions();
    var scrollOffset = {};
    if (!utils.isValueAssigned(overrideValues.vScrollOffset) || !utils.isValueAssigned(overrideValues.hScrollOffset)) {
      scrollOffset = getScrollOffset();
    }
    // Make the event
    var contentUpdateEvent = {
      name: "Ms.Webi.ContentUpdate",
      data: {
        baseData: {
          ver: MSCONTENT_PARTB_VERSION,
          impressionGuid: ids.getImpressionGuid(),
          pageName: overrideValues.pageName || getPageName(),
          uri: overrideValues.uri || getCurrentUri(),
          market: eventData.market,
          pageTags: JSON.stringify(utils.extend(true, pageTags, overrideValues.pageTags)),
          pageHeight: overrideValues.pageHeight || document.body.scrollHeight,
          vpHeight: viewportDim.h,
          vpWidth: viewportDim.w,
          actionType: overrideValues.actionType || eventData.actionType,
          behavior:
            getValidBehavior(overrideValues.behavior) ||
            (eventData.behavior ? eventData.behavior : awa.behavior.UNDEFINED),
          vScrollOffset: overrideValues.vScrollOffset || scrollOffset.v,
          hScrollOffset: overrideValues.hScrollOffset || scrollOffset.h,
          contentVer: CONTENT_VERSION,
          content:
            getContentInRightFormat(overrideValues.content) || getPageContent(getViewportBoundingRect(viewportDim))
        },
        baseType: "Ms.Content.ContentUpdate",
        timings: JSON.stringify(overrideValues.timings),
        title: overrideValues.title || getTitle(),
        cookieEnabled: getCookieEnabled(),
        isJs: true,
        isManual: true,
        isDomComplete: false,
        isLoggedIn: config.isLoggedIn,
        serverImpressionGuid: eventData.serverImpressionGuid
      },
      flags: eventData.isSensitive ? IS_SENSITIVE_FLAG : undefined
    };
    sendEventAfterOverridesAndStringify(contentUpdateEvent, overrideValues, eventData.env, false);
  }
  function sendCustomClickEvent(overrideValues) {
    sendClickEvent(null, overrideValues);
  }
  function sendElementClickEvent(element, overrideValues) {
    sendClickEvent(element, overrideValues);
  }
  function sendClickEvent(element, overrideValues) {
    /// <summary>
    ///  Extracts fields from objects and DOM, populates an event object
    /// <param type="DOM element"> a valid DOM element</param>
    /// <param name="overrideValues" type="object">
    ///  Override object that allows adopters to override the default collection behavior of AWA
    ///  The schema for the overrideValues object is:
    ///  {
    ///     "isAuto": true,
    ///     "behavior": 41,
    ///     "uri":"http://customuri",
    ///     "referrerUri": "http://bing.com?q=windowsstore",
    ///     "pageName": "mypagename",
    ///     "actionType": "CL",
    ///     "content": "mycontentvalue.  Entire content collected will be stomped by this.",
    ///     "contentTags": {},  // This will be "added" to the content collected by default population.
    ///     "targetUri":"http://msn.com/targeturi.aspx",
    ///     "pageTags":
    ///     {
    ///         "metaTags":{
    ///                     "meta1": "value1", "meta2":"value2"
    ///                    },
    ///         "custom1":"customvalue1",
    ///         "custom2":"customvalue2"
    ///     }
    ///  }
    /// </param>
    overrideValues = overrideValues || {};
    // If the element has DNT attribute then do not sendEvent, if MTO attribute is also present send the event
    var isMto = overrideValues.isAuto ? false : isTagFoundInElement(element, manualTrackingOnlyFieldName);
    if (element && isTagFoundInElement(element, doNotTrackFieldName) && !isMto) {
      awa.logger.logWarning("The element has do-not-track attribute set.  PageAction will not be sent.");
      return;
    }
    var allCookies = cookie.getAllCookies();
    var eventData = {};
    var pageTags = awa.utils.extend(true, config.coreData.pageTags);
    var elementContent = {};
    element = utils.returnDomObjectIfjQuery(element);
    if (element) {
      eventData.targetUri = getClickTarget(element);
      elementContent = getElementContent(element, true); // collect data-bi tags
      if (autoCapture.msTags) {
        elementContent = utils.extend(elementContent, getCustomTags(element)); // collect ms.* tags
      }
      // if the element has a data-bi-bhvr attrib defined, use it.  This value will be overridden if an override is passed in, below.
      if (elementContent.bhvr) {
        eventData.behavior = getValidBehavior(utils.extractFieldFromObject(elementContent, "bhvr"));
      }
    }
    // populate pageType, product, market, isSensitive, and others, in clickEventData
    pageTags.metaTags = collectMetaTagsAndSetEventProperty(eventData);
    setEnabledFeatures(pageTags, allCookies);
    if (typeof config.callback.pageActionPageTags === "function") {
      pageTags = utils.extend(true, pageTags, config.callback.pageActionPageTags(element));
    }
    var pageActionContentTags = config.callback.pageActionContentTags;
    // Make the event
    var pageActionEvent = {
      name: "Ms.Webi.PageAction",
      data: {
        baseData: {
          ver: MSCONTENT_PARTB_VERSION,
          impressionGuid: ids.getImpressionGuid(),
          pageName: overrideValues.pageName || getPageName(),
          uri: overrideValues.uri || getCurrentUri(),
          pageTags: utils.stringifyField("pageTags", utils.extend(true, pageTags, overrideValues.pageTags)),
          contentVer: CONTENT_VERSION,
          market: eventData.market,
          destUri: overrideValues.targetUri || eventData.targetUri,
          pageType: eventData.pageType,
          product: eventData.product,
          actionType: overrideValues.actionType || eventData.actionType,
          behavior:
            getValidBehavior(overrideValues.behavior) ||
            (eventData.behavior ? eventData.behavior : awa.behavior.UNDEFINED),
          content:
            getContentInRightFormat(overrideValues.content) ||
            utils.bracketIt(
              JSON.stringify(
                utils.extend(
                  elementContent,
                  typeof pageActionContentTags === "function" ? pageActionContentTags(element) : {},
                  overrideValues && overrideValues.contentTags ? overrideValues.contentTags : {}
                )
              )
            )
        },
        baseType: "Ms.Content.PageAction",
        timeToAction: getTimeToClick(),
        cookieEnabled: getCookieEnabled(),
        cookies: getClientCookies(allCookies),
        isJs: true,
        title: overrideValues.title || getTitle(),
        isLoggedIn: config.isLoggedIn,
        isManual: true,
        referrerUri: overrideValues.referrerUri || config.coreData.referrerUri,
        serverImpressionGuid: eventData.serverImpressionGuid
      },
      flags: eventData.isSensitive ? IS_SENSITIVE_FLAG : undefined
    };
    sendEventAfterOverridesAndStringify(pageActionEvent, overrideValues, eventData.env, true);
  }
  function resetPageUnloadProperties() {
    /// <summary> Resets the values used for pageUnload.</summary>
    awa.timespanHandler.recordTimeSpan("dwellTime", false);
    maxScroll.v = 0;
    isPageUnloadFired = false;
  }
  function sendPageUnload(overrideValues) {
    /// <summary> This method collects PageUnload schema data and sends event.</summary>
    if (!isPageUnloadFired) {
      isPageUnloadFired = true;
      overrideValues = overrideValues || {};
      overrideValues.isDomComplete = true;
      var eventData = {};
      collectMetaTagsAndSetEventProperty(eventData);
      var timingsCallback = config.callback.pageUnloadTimings;
      var scrollHeight = document.body.scrollHeight;
      // Make the event
      var pageUnloadEvent = {
        name: "Ms.Webi.PageUnload",
        data: {
          baseData: {
            ver: MSCONTENT_PARTB_VERSION,
            impressionGuid: ids.getImpressionGuid(),
            pageName: overrideValues.pageName || getPageName()
          },
          baseType: "Ms.Content.PageUnload",
          dwellTime: awa.timespanHandler.recordTimeSpan("dwellTime", true),
          scrollDepth: overrideValues.scrollDepth || maxScroll.v.toString() + "/" + scrollHeight.toString(),
          vScrollOffset: overrideValues.vScrollOffset || maxScroll.v,
          pageHeight: overrideValues.pageHeight || scrollHeight,
          vpHeight: getViewportDimensions().h,
          serverImpressionGuid: eventData.serverImpressionGuid,
          timings: timingsCallback ? timingsCallback() : undefined
        },
        flags: eventData.isSensitive ? IS_SENSITIVE_FLAG : undefined
      };
      sendEventAfterOverridesAndStringify(pageUnloadEvent, overrideValues, eventData.env, true);
    }
  }
  function sendClientError(overrideValues) {
    if (overrideValues) {
      var eventData = {};
      collectMetaTagsAndSetEventProperty(eventData);
      var clientErrorEvent = {
        name: "Ms.Webi.ClientError",
        data: {
          errorInfo: JSON.stringify(overrideValues.errorInfo),
          wasDisplayed: overrideValues.displayedToUser || false,
          impressionGuid: ids.getImpressionGuid(),
          pageName: overrideValues.pageName || getPageName(),
          uri: overrideValues.uri || getCurrentUri(),
          market: eventData.market,
          serverImpressionGuid: eventData.serverImpressionGuid
        },
        flags: eventData.isSensitive ? IS_SENSITIVE_FLAG : undefined
      };
      sendEventAfterOverridesAndStringify(clientErrorEvent, overrideValues, eventData.env, false);
    }
  }
  function sendCorsDisallowed(overrideValues) {
    if (overrideValues) {
      var eventData = {};
      collectMetaTagsAndSetEventProperty(eventData);
      var corsDisallowedEvent = {
        name: "Ms.Cll.Javascript.CorsDisallowed",
        data: {
          eventName: overrideValues.eventName,
          pageName: getPageName(),
          uri: overrideValues.uri || getCurrentUri(),
          market: eventData.market,
          impressionGuid: ids.getImpressionGuid(),
          serverImpressionGuid: eventData.serverImpressionGuid
        },
        flags: eventData.isSensitive ? IS_SENSITIVE_FLAG : undefined
      };
      sendEventAfterOverridesAndStringify(corsDisallowedEvent, overrideValues, eventData.env, false);
    }
  }
  function sendEventTooLong(overrideValues) {
    if (overrideValues) {
      var eventData = {};
      collectMetaTagsAndSetEventProperty(eventData);
      var eventTooLongEvent = {
        name: "Ms.Cll.Javascript.EventTooLong",
        data: {
          eventName: overrideValues.eventName,
          payloadLength: overrideValues.payloadLength,
          pageName: overrideValues.pageName || getPageName(),
          uri: overrideValues.uri || getCurrentUri(),
          market: eventData.market,
          impressionGuid: ids.getImpressionGuid(),
          serverImpressionGuid: eventData.serverImpressionGuid
        },
        flags: eventData.isSensitive ? IS_SENSITIVE_FLAG : undefined
      };
      sendEventAfterOverridesAndStringify(eventTooLongEvent, overrideValues, eventData.env, false);
    }
  }
  function sendEventDropped(overrideValues) {
    if (overrideValues && autoCapture.invalidEvents) {
      var eventData = {};
      collectMetaTagsAndSetEventProperty(eventData);
      var eventTooLongEvent = {
        name: "Ms.Cll.Javascript.EventDropped",
        data: {
          eventName: overrideValues.eventName,
          droppedInfo: overrideValues.droppedInfo,
          pageName: overrideValues.pageName || getPageName(),
          uri: overrideValues.uri || getCurrentUri(),
          market: eventData.market,
          impressionGuid: ids.getImpressionGuid(),
          serverImpressionGuid: eventData.serverImpressionGuid
        },
        flags: eventData.isSensitive ? IS_SENSITIVE_FLAG : undefined
      };
      sendEventAfterOverridesAndStringify(eventTooLongEvent, overrideValues, eventData.env, false);
    }
  }
  function sendIdSwap(overrideValues) {
    // no op for now, this method will be called by Adobe services
    return;
  }
  function extendAndSendQos(qosEvent) {
    var eventData = {};
    collectMetaTagsAndSetEventProperty(eventData);
    var partC = qosEvent.data;
    partC.serverImpressionGuid = eventData.serverImpressionGuid;
    partC.market = eventData.market;
    partC.pageName = getPageName();
    partC.uri = getCurrentUri();
    sendEventAfterOverridesAndStringify(qosEvent, undefined, eventData.env, false);
  }
  function populateOverridesInEvent(event, partC, overrideValues) {
    /// <summary> Given an event, partB object, partC object, and override values,
    /// overwrite values in event with values from overrideValues </summary>
    /// <param type="Object"> event </param>
    /// <param type="Object"> part B of event </param>
    /// <param type="Object"> part C of event </param>
    /// <param type="Object"> override values </param>
    // PartA overrides
    if (overrideValues.appId) {
      event.appId = overrideValues.appId;
    }
    if (overrideValues.serviceName) {
      event.serviceName = overrideValues.serviceName;
    }
    // PartC overrides
    if (overrideValues.isAuto !== true) {
      partC.isManual = true;
    } else {
      partC.isManual = undefined;
    }
    if (overrideValues.isDomComplete) {
      partC.isDomComplete = overrideValues.isDomComplete;
      // Automatically capture PLT for DOM complete events.  It could be overridden below though.
      partC.pageLoadTime = overrideValues.pageLoadTime || utils.getPageLoadTime();
    }
  }
  function getContentInRightFormat(content) {
    if (utils.isValueAssigned(content)) {
      if (Object.prototype.toString.call(content) === "[object Array]") {
        return JSON.stringify(content);
      } else {
        return utils.bracketIt(JSON.stringify(content));
      }
    }
    return undefined;
  }
  function sendEventAfterOverridesAndStringify(event, overrideValues, env, isCritical) {
    event.time = utils.dateToISOString(new Date());
    var partC = event.data;
    // At this point the event has all default values that we collect.  Overwrite them as necessary.
    if (overrideValues) {
      populateOverridesInEvent(event, partC, overrideValues);
    }
    // do not populate an extension property bag if it is not guaranteed to contain at least one field.
    // in this case, if it is undefined, the app extension will still be populated as an empty object
    // in beacon and POST
    if (env) {
      event.ext = {
        app: {
          env: env
        }
      };
    }
    // send event
    vortexEvents.SendOrScheduleEvent(event, isCritical);
  }
  function getTimeToClick() {
    // capture performance data into PageTags
    if (window.performance && window.performance.timing) {
      var isNavigationStart = window.performance.timing.navigationStart;
      if (isNavigationStart !== 0) {
        return new Date().getTime() - isNavigationStart;
      }
    }
    return -1;
  }
  function getViewportBoundingRect(viewportDimensions) {
    var viewportBoundingRect = {
      top: 0,
      bottom: viewportDimensions.h,
      left: 0,
      right: viewportDimensions.w
    };
    return viewportBoundingRect;
  }
  function getPageContent(viewportBoundingRect) {
    /// <summary>
    ///  Collect data-bi attributes for the given area and slots in the current viewport.
    ///  If an area is not specified only slots in the current viewport are considered.
    /// </summary>
    /// <param type="Object">The element from which attributes need to be collected.</param>
    /// <returns type="String">String representation of the Json array of content elements</returns>
    var arrayOfContents = [];
    // Select all elements that have data-bi-area/aN, data-bi-slot/sN or data-m (biAttributeName) defined in the viewPort.
    var elementsToCapture = document.querySelectorAll(
      utils.bracketIt(contentBlobFieldNames.areaName) +
        "," +
        utils.bracketIt(contentBlobFieldNames.slotNumber) +
        "," +
        utils.bracketIt(config.biBlobAttributeTag)
    );
    pushToArrayOfContentsIfVisible(elementsToCapture, arrayOfContents, viewportBoundingRect);
    return JSON.stringify(arrayOfContents);
  }
  function pushToArrayOfContentsIfVisible(elements, arrayOfContents, viewportBoundingRect) {
    /// <summary> takes an array of elements and only pushes the visible ones to arrayOfContents </summary>
    /// <param type="object"> the list of elements </param>
    /// <param type="object"> the array to push in </param>
    if (elements) {
      for (var i = 0; i < elements.length; i++) {
        // DNT = Do Not Track
        var element = elements[i];
        if (!isTagFoundInElement(element, doNotTrackFieldName)) {
          if (utils.isElementTrulyVisible(element, viewportBoundingRect)) {
            var elementContent = getElementContent(element, false);
            if (elementContent) {
              arrayOfContents.push(elementContent);
            }
          }
        }
      }
    }
  }
  /// <summary>
  /// Computes the lineage of a given element.
  /// </summary>
  /// <returns>An object containing the different forms of lineage/hierarchy on DOM tree starting with the current element.
  /// example output: "lineage":"GET OFFICE 365>coreui-hero-6zx3vxo-item-2>R1Hero 1>primaryR1 1>primaryArea 1",
  /// "lineageOrdinal":"10>9>1>1>2","lineageById":"n10m1r1a2>nn9m1r1a2>m1r1a2>r1a2>a2Body","containerName":"R1Hero 1",
  /// "lineageTags":[{},{},{"varId":"hsro4re"},{},{}]}]
  /// </returns>
  function getLineageDetails(element) {
    var name = [];
    var identifier = [];
    var lineageDelimiter = ">";
    var elementBiDataAttribute = config.biBlobAttributeTag; // data-m
    var elementModuleIdAttribute = "data-module-id";
    var containerName = undefined;
    var nameValue;
    var idValue;
    while (element && element.getAttribute) {
      var dataAttr = element.getAttribute(elementBiDataAttribute) || element[elementBiDataAttribute];
      var moduleIdAttribute = element.getAttribute(elementModuleIdAttribute) || element[elementModuleIdAttribute];
      if (dataAttr) {
        var telemetryObject = JSON.parse(dataAttr);
        if (telemetryObject) {
          nameValue = telemetryObject.cN || telemetryObject.cT;
          idValue = telemetryObject.id || undefined;
          if (nameValue || idValue) {
            name.push(nameValue);
            if (moduleIdAttribute) {
              // reporting treats cN of modules as containerName
              containerName = nameValue;
            }
            identifier.push(idValue);
          }
        }
      } else {
        nameValue =
          element.getAttribute(contentBlobFieldNames.contentName) ||
          element.getAttribute(contentBlobFieldNames.contentType);
        idValue = element.getAttribute(contentBlobFieldNames.id) || undefined;
        if (nameValue || idValue) {
          name.push(nameValue);
          if (moduleIdAttribute) {
            containerName = nameValue;
          }
          identifier.push(idValue);
        }
      }
      element = element.parentElement;
    }
    var lineageDetails = {
      lineage: name.join(lineageDelimiter),
      lineageById: identifier.join(lineageDelimiter),
      containerName: containerName
    };
    return lineageDetails;
  }
  function getElementContent(element, isPageAction) {
    /// <summary>
    ///  Collect data-bi attributes for the given element.
    /// </summary>
    /// <param type="Object">The element from which attributes need to be collected.</param>
    /// <param type="Boolean">Determines if the event is a pageAction to collect lineage.</param>
    /// <returns type="String">String representation of the Json array of element attributes</returns>
    /// <remarks>All attributes with data-bi prefix are collected.  "data-bi" prefix is removed from the key name.</remarks>
    if (!element) {
      return "";
    }
    var elementContent = {};
    // capture config.biBlobAttributeTag blob from element or hierarchy
    var biBlobElement = awa.utils.findClosestByAttribute(element, config.biBlobAttributeTag);
    var biBlobValue;
    if (biBlobElement) {
      biBlobValue = biBlobElement.getAttribute(config.biBlobAttributeTag);
    }
    if (biBlobValue) {
      elementContent = JSON.parse(biBlobValue);
    } else {
      // Get the element if it has data-bi-id defined.  If not traverse up the DOM to find the closest parent with data-bi-id defined
      var contentElement = utils.findClosestByAttribute(element, utils.bracketIt(contentBlobFieldNames.id));
      contentElement = utils.returnDomObjectIfjQuery(element);
      // Get the closest element with attribute data-bi-area.
      var areaElement = utils.findClosestByAttribute(element, contentBlobFieldNames.areaName);
      var areaContent = awa.utils.extend({}, getAreaContent(areaElement));
      elementContent = {
        id: contentElement.getAttribute(contentBlobFieldNames.id) || element.id || "",
        aN: areaContent.areaName,
        sN: contentElement.getAttribute(contentBlobFieldNames.slotNumber),
        cN:
          contentElement.getAttribute(contentBlobFieldNames.contentName) ||
          getDefaultContentName(element) ||
          contentElement.getAttribute("alt") ||
          "",
        cS: contentElement.getAttribute(contentBlobFieldNames.contentSource) || areaContent.contentSource,
        tN: areaContent.templateName,
        pid: contentElement.getAttribute(contentBlobFieldNames.productId),
        cT: contentElement.getAttribute(contentBlobFieldNames.contentType) || areaContent.type
      };
      // Validate to ensure the minimum required field "contentName/cN" is present.
      // The content schema defines id, aN and sN as required fields.  However,
      /// requiring these fields would result in majority of adopter's content from being collected.
      // Just throw a warning and continue collection.
      if (!elementContent.id || !elementContent.aN || !elementContent.sN || !elementContent.cN) {
        awa.logger.logWarning(
          "Invalid content blob.  Missing required attributes (id, aN/area, sN/slot), cN/contentName. " +
            " Content information will still be collected!"
        );
      }
      // use legacy fullNames for the content blob if configured so.
      if (!contentBlobFieldNames.isShortNames) {
        elementContent = {
          contentId: elementContent.id,
          areaName: elementContent.aN,
          slotNumber: elementContent.sN,
          contentName: elementContent.cN,
          contentSource: elementContent.cS,
          templateName: elementContent.tN,
          productId: elementContent.pid,
          contentType: elementContent.cT
        };
      }
      // Collect all other data-bi attributes and name them w/o the data-bi prefix.
      for (var i = 0, attrib; i < contentElement.attributes.length; i++) {
        attrib = contentElement.attributes[i];
        if (
          attrib.name === contentBlobFieldNames.id ||
          attrib.name === contentBlobFieldNames.areaName ||
          attrib.name === contentBlobFieldNames.slotNumber ||
          attrib.name === contentBlobFieldNames.contentName ||
          attrib.name === contentBlobFieldNames.contentSource ||
          attrib.name === contentBlobFieldNames.templateName ||
          attrib.name === contentBlobFieldNames.productId ||
          attrib.name === contentBlobFieldNames.contentType ||
          attrib.name.indexOf("data-bi-") === -1
        ) {
          continue;
        }
        var attribName = attrib.name.replace("data-bi-", "");
        elementContent[attribName] = attrib.value;
      }
    }
    awa.utils.removeInvalidElements(elementContent);
    if (config.autoCapture.lineage && isPageAction) {
      elementContent = awa.utils.extend(elementContent, getLineageDetails(element));
    }
    return elementContent;
  }
  /*ignore jslint start*/
  function getDefaultContentName(element) {
    if (config.useDefaultContentName === false || isPii(element) || !element.tagName) {
      return "";
    }
    var contentName;
    switch (element.tagName) {
      case "A":
        contentName = document.all ? element.innerText || element.innerHTML : element.text || element.innerHTML;
      case "IMG":
      case "AREA":
        contentName = element.alt;
      default:
        contentName = element.value || element.name || element.alt || element.innerText || element.id;
    }
    return contentName.substring(0, MAX_CONTENTNAME_LENGTH);
  }
  /*ignore jslint end*/
  function getAreaContent(areaElement) {
    /// <summary> extracts area content from element</summary>
    /// <param type="object"> area DOM element </param>
    /// <returns> JSON object </returns>
    areaElement = utils.returnDomObjectIfjQuery(areaElement);
    if (areaElement) {
      return {
        areaName: areaElement.getAttribute(contentBlobFieldNames.areaName),
        templateName: areaElement.getAttribute(contentBlobFieldNames.templateName),
        contentSource: areaElement.getAttribute(contentBlobFieldNames.contentSource),
        product: areaElement.getAttribute(contentBlobFieldNames.productId),
        type: areaElement.getAttribute(contentBlobFieldNames.contentType)
      };
    }
  }
  function getClientCookies(allCookies) {
    var cookies = "";
    var uniqueCookies = {};
    var mergedCookies = [];
    var cookiesConfig = config.cookiesToCollect;
    if (config.shareAuthStatus === false) {
      // collect ANON if it is in cookiesConfig
      mergedCookies = cookiesConfig;
    } else {
      // do not collect ANON even if it is in cookiesConfig
      for (var i = 0; i < cookiesConfig.length; i++) {
        if (cookiesConfig[i] !== "ANON") {
          mergedCookies.push(cookiesConfig[i]);
        }
      }
    }
    var key;
    var cookieValue;
    try {
      try {
        // adding a try catch block to ensure any mis-handling
        // of the varCustomerCookies variable by adopters is not impacting the rest.
        if (window.varCustomerCookies && window.varCustomerCookies.length > 0) {
          mergedCookies = mergedCookies.concat(window.varCustomerCookies);
        }
      } catch (e) {}
      for (key in mergedCookies) {
        if (mergedCookies.hasOwnProperty(key)) {
          // de-dupe the list, no value is necessary hence ""
          if (!uniqueCookies.hasOwnProperty(mergedCookies[key])) {
            uniqueCookies[mergedCookies[key]] = "";
            cookieValue = allCookies[mergedCookies[key]];
            if (cookieValue && cookieValue !== "") {
              cookies += mergedCookies[key] + "=" + cookieValue + ";";
            }
          }
        }
      }
    } catch (e) {}
    return cookies;
  }
  function getClickTarget(element) {
    var clickTarget = "";
    switch (element.tagName) {
      case "A":
      case "AREA":
        clickTarget = element.href || "";
        break;
      case "IMG":
        clickTarget = getImageHref(element);
        break;
      case "INPUT":
        var type = element.type;
        var e = window.event;
        if (type && clickCaptureInputTypes[type.toUpperCase()]) {
          if (element.form) {
            clickTarget = element.form.action || window.location.pathname;
          } else {
            clickTarget = window.location.pathname;
          }
        }
        break;
      default:
        break;
    }
    return clickTarget;
  }
  function getCustomTags(obj) {
    /// <summary>Collect data from attributes that have a ms. prefix.
    /// This functionality is there to provide compatibility with WEDCS.
    ///   TODO: When all adopters have moved to the new tagging taxanomy we can remove this functionality.
    /// </summary>
    /// <param type="Object">The element from which attributes need to be collected.</param>
    /// <returns type="Object">Tags collection/property bag</returns>
    var customParameters = {};
    while (obj) {
      if (isPii(obj)) {
        continue;
      }
      for (var attr in obj.attributes) {
        if (attr) {
          if (obj.attributes[attr]) {
            var nn = obj.attributes[attr].name;
            if (nn) {
              if (nn.toLowerCase().indexOf("ms.") === 0) {
                customParameters[nn] = obj.attributes[attr].value;
              }
            }
          }
        }
      }
      obj = obj.parentElement || obj.parentNode;
    }
    return customParameters;
  }
  function getFlashInfo() {
    var flashInfo = {};
    if (navigator.plugins["Shockwave Flash"]) {
      flashInfo.installed = true;
      var plugin = navigator.plugins["Shockwave Flash"];
      flashInfo.version = plugin.description.split(" ")[2];
    } else if (navigator.userAgent.indexOf("MSIE") !== -1) {
      var flashMax = new Date().getFullYear() - 1992;
      for (var i = flashMax; i > 0; i--) {
        try {
          var flash = new ActiveXObject("ShockwaveFlash.ShockwaveFlash." + i); // ignore jslint
          flashInfo.installed = true;
          flashInfo.version = i + ".0";
          break;
        } catch (e) {}
      }
    }
    return flashInfo;
  }
  function setEnabledFeatures(pageTags, allCookies) {
    /// <summary>
    ///  Sets the enabledFeatures property in the passed in object, with the value of the cookie named "Features"
    /// </summary>
    if (config.enabledFeatures) {
      if (pageTags.enabledFeatures) {
        return;
      }
      var enabledFeatures = allCookies["Features"];
      if (enabledFeatures) {
        pageTags.enabledFeatures = enabledFeatures;
      }
    }
  }
  function collectMetaTagsAndSetEventProperty(event, isPageView) {
    /// <summary>Collect data from meta tags. Assign specific field values
    /// in the event object.Return an object that is a kvp of awa- and ms.tags. </summary>
    /// <param type="Object">Event object whose fields will be assigned to</param>
    /// <returns type="Object">Metatags collection/property bag</returns>
    var awaTags = {};
    var msTags = {};
    // Collect the awa-* tags.
    if (config.autoCapture.awaTags) {
      awaTags = getMetaDataFromDom("awa-", true);
    }
    event.env = getMetaData(awaTags, config.coreData, "env");
    event.pageType = getMetaData(awaTags, config.coreData, "pageType");
    event.product = getMetaData(awaTags, config.coreData, "product");
    event.market = getMetaData(awaTags, config.coreData, "market");
    event.serverImpressionGuid = getMetaData(awaTags, config.coreData, "serverImpressionGuid");
    event.isSensitive = getMetaData(awaTags, config.coreData, "isSensitive");
    if (!event.behavior && isPageView) {
      event.behavior = getValidBehavior(getMetaData(awaTags, config.coreData, "behavior"));
    }
    if (config.autoCapture.msTags) {
      // Collect the legacy ms.* tags and append them to the metaTags.
      msTags = getMetaDataFromDom("ms.", false);
      awaTags = utils.extend(true, awaTags, msTags);
    }
    return awaTags;
  }
  function getMetaData(awaTags, coreData, metaTagName) {
    /// <summary>
    ///     If overrideValue is specified in the config that takes precedence.
    /// However, in order to prevent the tag value found in the meta element in the dom from being used
    ///     we must extract (remove) the given tag from the pageTags collection.
    /// <param type="Object" name="awaTags">contains meta tags</param>
    if (coreData[metaTagName]) {
      return coreData[metaTagName];
    } else {
      return utils.extractFieldFromObject(awaTags, metaTagName);
    }
  }
  function getMetaDataFromDom(prefix, removePrefix) {
    var metaElements;
    var metaData = {};
    metaElements = document.querySelectorAll("meta");
    for (var i = 0; i < metaElements.length; i++) {
      var meta = metaElements[i];
      if (meta.name) {
        var mt = meta.name.toLowerCase();
        if (mt.indexOf(prefix) === 0) {
          var name = removePrefix ? meta.name.replace(prefix, "") : meta.name;
          metaData[name] = meta.content;
        }
      }
    }
    return metaData;
  }
  function getScreenResolution() {
    /// <summary>
    ///  Gets the screen resolution object.
    /// </summary>
    /// <returns type="Object">Returns a ScreenResolution object.</remarks>
    var screenRes = { h: 0, w: 0 };
    if (window.screen) {
      screenRes.h = screen.height;
      screenRes.w = screen.width;
    }
    return screenRes;
  }
  function getViewportDimensions() {
    /// <summary>
    ///  Use window dimensions if available before reaching into DOM.
    /// Accessing DOM frequently causes layout to reflow and impacts perf.
    /// </summary>
    /// <returns type="Object">Returns a Viewport object that contains dimensions
    /// of the current viewport.</remarks>
    /// <remakrs>When this is executed from within an iFrame, the dimensions
    /// would be that of the iFrame and not the browser window.</remarks>
    var viewport = { h: 0, w: 0 };
    if (window.screen) {
      viewport.h = window.innerHeight || document.body.clientHeight || document.documentElement.clientHeight;
      viewport.w = window.innerWidth || document.body.clientWidth || document.documentElement.clientWidth;
    }
    return viewport;
  }
  function getScrollOffset() {
    /// <summary>
    ///  Returns the scroll offset
    /// </summary>
    var scrollOffset = {
      h: parseInt(document.body.scrollLeft || document.documentElement.scrollLeft || window.pageXOffset || 0, 10),
      v: parseInt(document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset || 0, 10)
    };
    return scrollOffset;
  }
  function getCookieEnabled() {
    /// <summary>
    ///  Returns a boolean value indicating if Cookies are enabled on the browser.
    /// </summary>
    return navigator.cookieEnabled;
  }
  function getImageHref(element) {
    var temp = element;
    if (temp) {
      var parent = utils.findClosestAnchor(temp);
      if (parent && parent.length === 1) {
        if (parent[0].href) {
          return parent[0].href;
        } else if (parent[0].src) {
          return parent[0].src;
        }
      }
    }
    return "";
  }
  function isPii(element) {
    if (!element || !element.attributes) {
      return false;
    }
    try {
      var pii = element.getAttribute("data-dc");
      if (utils.isValueAssigned(pii)) {
        if (pii.toLowerCase() === "pii") {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }
  function isBehaviorValid(behaviorValue) {
    /// <summary> validates the behavior value, logs warning if invalid. </summary>
    /// <param type="Number"> Behavior value </param>
    /// <returns type="Bool"> true if behavior is valid </returns>
    for (var i = 0; i < awa.behaviorKeys.length; i++) {
      if (awa.behavior[awa.behaviorKeys[i]] === behaviorValue) {
        return true;
      }
    }
    awa.logger.logWarning("Unsupported behavior: " + behaviorValue + ".");
    return false;
  }
  function getValidBehavior(behaviorValue) {
    /// <summary> populates the object with the right behavior value </summary>
    /// <param type="number or string"> Behavior value or behavior key of the event </param>
    /// <returns type="number"> the valid behavior value that is populated in the event </returns>
    if (utils.isValueAssigned(behaviorValue)) {
      var behaviorValueNumber = Number(behaviorValue);
      if (utils.isOfCorrectType("uint16", behaviorValueNumber)) {
        if (isBehaviorValid(behaviorValueNumber)) {
          return behaviorValueNumber; // extract methods return a string.  Converting to number to be safe.
        }
      } else if (utils.isOfCorrectType("string", behaviorValue)) {
        var value = awa.behavior[behaviorValue.toUpperCase()];
        if (utils.isOfCorrectType("uint16", value)) {
          return value;
        }
      }
    }
    return undefined;
  }
  function getCurrentUri() {
    return getUri(window.location);
  }
  function getUri(windowLocation) {
    // <summary> returns full, trimmed, or config custom page URI </summary>
    /// <returns type="string"> the trimmed, full, or config uri, depending on settings </returns>
    // check for window.location because in IE8 anyone can replace the location object
    if (config.coreData.requestUri === "" && windowLocation) {
      var url =
        windowLocation.protocol +
        "//" +
        windowLocation.hostname +
        (utils.isValueAssigned(windowLocation.port) ? ":" + windowLocation.port : "") +
        windowLocation.pathname;
      if (config.urlCollectHash) {
        url += windowLocation.hash;
      }
      if (config.urlCollectQuery) {
        var query = windowLocation.search;
        if (!query) {
          // in older browsers the query parameters can be contained in the hash
          var hash = window.location.hash;
          var queryIndex = hash.indexOf("?");
          if (queryIndex != -1) {
            query = hash.slice(queryIndex);
          }
        }
        url += query;
      }
      return url;
    } else {
      return config.coreData.requestUri;
    }
  }
  return {
    initialize: init,
    capturePageView: sendPageView,
    captureContentUpdate: sendContentUpdate,
    capturePageAction: sendElementClickEvent,
    captureContentPageAction: sendCustomClickEvent,
    capturePageUnload: sendPageUnload,
    captureCorsDisallowed: sendCorsDisallowed,
    captureEventTooLong: sendEventTooLong,
    captureClientError: sendClientError,
    captureEventDrop: sendEventDropped,
    captureQos: extendAndSendQos,
    captureSwap: sendIdSwap,
    domReadyTasksWrapper: domReadyTasksWrapper,
    onDomReadyDo: onDomReadyDo,
    domReadyTasks: domReadyTasks,
    getTimeToClick: getTimeToClick,
    getPageContent: getPageContent,
    getUri: getUri,
    testHook: {
      isBehaviorValid: isBehaviorValid,
      getValidBehavior: getValidBehavior,
      collectMetaTagsAndSetEventProperty: collectMetaTagsAndSetEventProperty,
      getElementContent: getElementContent,
      getPageContent: getPageContent,
      debounce: debounce,
      getScreenResolution: getScreenResolution,
      getViewportDimensions: getViewportDimensions
    } ///#ENDDEBUG
  };
})();
// -----------------------------------------------------------------------
//  <copyright file="service.ts" company="Microsoft">
//      Copyright (c) Microsoft. All rights reserved.
//  </copyright>
//  <summary>
//      This module contains the Service module
//  </summary>
// -----------------------------------------------------------------------
awa.service = (function () {
  var timespanHandler = awa.timespanHandler;
  var willChangeSupportCors = true;
  var alwaysAddCvToRequestHeader = false;
  var targetUriOverrideCallbackFunction = null;
  var makeRequest = function (requestOptions) {
    /// <summary> makes the ajax request and fires the OSR event </summary>
    ///  <param> Most of the options directly maps to Jquery ajax api, please refer to http://api.jquery.com/jQuery.ajax/ for more details
    ///     requestOptions = {
    ///         operationName: name of the operation
    ///         serviceName: name of the service
    ///         url: endpoint called,
    ///         method: GET, PUT, POST, etc
    ///         contentType: contentType of post,
    ///         additionalHeaders: {header: 'value'},
    ///         body: object that will be posted as JSON,
    ///         data: (when body is absent) object that will be sent as query,
    ///         dataType: what the data type is, if absent, default to "json", set "auto" if the calls lets the Api decide the type.
    ///         accept: accept header value,
    ///         maxRetry: max allowable number of retries,
    ///         noCacheBusting: true to prevent cache busting parameter,
    ///         errorFormatter: errorFormatter to use for formatting details about service errors (defaults to just the error object itself),
    ///         defaultError: default error to return for unclassified service errors,
    ///         currentOperationName: the operation name that calls this API, in web it could be the pagename.
    ///         jsonp: Override the callback function name in a JSONP request.
    ///         jsonpCallback: Specify the callback function name for a JSONP request.
    ///         success: Optional. Callback function to run if the request succeeds.
    ///         error: Optional. Callback function to run if the request results in an error.
    ///         customDataCallback: Optional. Callback function that takes jqXhr as parameter and returns a Object that contains any custom data to the event.
    ///         xhrFields: Optional. provide xhrFields headers, will be copied to options.xhfFields.
    ///         cV: Optional. Passing a cV in the requestOptions will set that cV on the appropriate OSR event
    ///         addCvToRequestHeader: Optional. Bool. true will add the cV on the service request in the "MS-CV" header. Will override awa.service.alwaysAddCvToRequestHeader()
    ///         accepts: A set of key/value pairs that map a given dataType to its MIME type, which gets sent in the Accept request header. This header tells the server what kind of response it will accept in return. For example, the following defines a custom type mycustomtype to be sent with the request:
    ///         async: By default, all requests are sent asynchronously (i.e. this is set to true by default). If you need synchronous requests, set this option to false. Cross-domain requests and dataType: "jsonp" requests do not support synchronous operation. Note that synchronous requests may temporarily lock the browser, disabling any actions while the request is active. As of jQuery 1.8, the use of async: false with jqXHR ($.Deferred) is deprecated; you must use the success/error/complete callback options instead of the corresponding methods of the jqXHR object such as jqXHR.done().
    ///         complete: A function to be called when the request finishes (after success and error callbacks are executed). The function gets passed two arguments: The jqXHR (in jQuery 1.4.x, XMLHTTPRequest) object and a string categorizing the status of the request ("success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"). As of jQuery 1.5, the complete setting can accept an array of functions. Each function will be called in turn. This is an Ajax Event.
    ///         contents: An object of string/regular-expression pairs that determine how jQuery will parse the response, given its content type. (version added: 1.5)
    ///         context:This object will be the context of all Ajax-related callbacks. By default, the context is an object that represents the Ajax settings used in the call ($.ajaxSettings merged with the settings passed to $.ajax). For example, specifying a DOM element as the context will make that the context for the complete callback of a request
    ///         dataFilter: A function to be used to handle the raw response data of XMLHttpRequest. This is a pre-filtering function to sanitize the response. You should return the sanitized data. The function accepts two arguments: The raw data returned from the server and the 'dataType' parameter.
    ///         global:Whether to trigger global Ajax event handlers for this request. The default is true. Set to false to prevent the global handlers like ajaxStart or ajaxStop from being triggered. This can be used to control various Ajax Events.
    ///         ifModified: Allow the request to be successful only if the response has changed since the last request. This is done by checking the Last-Modified header. Default value is false, ignoring the header. In jQuery 1.4 this technique also checks the 'etag' specified by the server to catch unmodified data.
    ///         isLocal:Allow the current environment to be recognized as "local," (e.g. the filesystem), even if jQuery does not recognize it as such by default. The following protocols are currently recognized as local: file, *-extension, and widget. If the isLocal setting needs modification, it is recommended to do so once in the $.ajaxSetup() method. (version added: 1.5.1)
    ///         mimeType: A mime type to override the XHR mime type. (version added: 1.5.1)
    ///         password: A password to be used with XMLHttpRequest in response to an HTTP access authentication request.
    ///         processData:By default, data passed in to the data option as an object (technically, anything other than a string) will be processed and transformed into a query string, fitting to the default content-type "application/x-www-form-urlencoded". If you want to send a DOMDocument, or other non-processed data, set this option to false.
    ///         scriptCharset: Only applies when the "script" transport is used (e.g., cross-domain requests with "jsonp" or "script" dataType and "GET" type). Sets the charset attribute on the script tag used in the request. Used when the character set on the local page is not the same as the one on the remote script.
    ///         statusCode:An object of numeric HTTP codes and functions to be called when the response has the corresponding code. If the request is successful, the status code functions take the same parameters as the success callback; if it results in an error (including 3xx redirect), they take the same parameters as the error callback.
    ///         traditional: Set this to true if you wish to use the traditional style of param serialization.
    ///         type :An alias for method. You should use type if you're using versions of jQuery prior to 1.9.0.
    ///         username:A username to be used with XMLHttpRequest in response to an HTTP access authentication request.
    ///         xhr:Callback for creating the XMLHttpRequest object. Defaults to the ActiveXObject when available (IE), the XMLHttpRequest otherwise. Override to provide your own implementation for XMLHttpRequest or enhancements to the factory.
    ///     }
    ///</param>
    /// <returns> The jQuery XMLHttpRequest (jqXHR) object returned by $.ajax() </returns>
    if (typeof jQuery === "function") {
      if (willChangeSupportCors) {
        // in IE support.cors was sometimes false, even though it should always be true. When it was false, it resulted in No Transport error
        $.support.cors = true;
      }
      var additionalHeaders = requestOptions.additionalHeaders || {};
      var body = requestOptions.body;
      var requestData = body ? JSON.stringify(body) : requestOptions.data || undefined;
      var maxRetry = requestOptions.maxRetry || 0;
      var retryCount = 0;
      var jqXhrCallback = $.noop;
      var operationName = requestOptions.operationName || requestOptions.url;
      var errorFormatter =
        requestOptions.errorFormatter ||
        function (jqXhr) {
          return jqXhr;
        };
      var ids = awa.ids;
      var cachedCv;
      var options = {
        url: requestOptions.url,
        type: requestOptions.method,
        data: requestData,
        crossDomain: true,
        headers: {},
        success: requestOptions.success,
        timeout: requestOptions.timeout,
        error: requestOptions.error,
        jsonp: requestOptions.jsonp,
        jsonpCallback: requestOptions.jsonpCallback,
        cache: requestOptions.cache,
        beforeSend: function (jqXhr) {
          jqXhrCallback(jqXhr);
          if (requestOptions.contractVersion) {
            jqXhr.setRequestHeader("MS-Contract-Version", requestOptions.contractVersion);
          }
          if (
            (!awa.utils.isValueAssigned(requestOptions.addCvToRequestHeader) && alwaysAddCvToRequestHeader) ||
            requestOptions.addCvToRequestHeader
          ) {
            if (awa.cv.isValid(cachedCv)) {
              jqXhr.setRequestHeader("MS-CV", cachedCv);
            }
          }
          if (additionalHeaders) {
            for (var header in additionalHeaders) {
              jqXhr.setRequestHeader(header, additionalHeaders[header]);
            }
          }
        }
      };
      if (requestOptions.dataType) {
        options.dataType = requestOptions.dataType;
      }
      if (!requestOptions.noCacheBusting) {
        /*IE likes to cache responses, this will add a random query string parameter to each request to prevent caching*/
        options.cache = false;
      }
      if (requestOptions.contentType) {
        options.contentType = requestOptions.contentType;
      }
      if (requestOptions.accept) {
        options.headers.Accept = requestOptions.accept;
      }
      if (requestOptions.accepts) {
        options.accepts = requestOptions.accepts;
      }
      if (requestOptions.async) {
        options.async = requestOptions.async;
      }
      if (requestOptions.xhrFields) {
        options.xhrFields = requestOptions.xhrFields;
      }
      if (requestOptions.complete) {
        options.complete = requestOptions.complete;
      }
      if (requestOptions.contents) {
        options.contents = requestOptions.contents;
      }
      if (requestOptions.context) {
        options.context = requestOptions.context;
      }
      if (requestOptions.dataFilter) {
        options.dataFilter = requestOptions.dataFilter;
      }
      if (requestOptions.global) {
        options.global = requestOptions.global;
      }
      if (requestOptions.ifModified) {
        options.ifModified = requestOptions.ifModified;
      }
      if (requestOptions.isLocal) {
        options.isLocal = requestOptions.isLocal;
      }
      if (requestOptions.mimeType) {
        options.mimeType = requestOptions.mimeType;
      }
      if (requestOptions.password) {
        options.password = requestOptions.password;
      }
      if (awa.utils.isValueAssigned(requestOptions.processData)) {
        options.processData = requestOptions.processData;
      }
      if (requestOptions.scriptCharset) {
        options.scriptCharset = requestOptions.scriptCharset;
      }
      if (requestOptions.statusCode) {
        options.statusCode = requestOptions.statusCode;
      }
      if (requestOptions.traditional) {
        options.traditional = requestOptions.traditional;
      }
      if (requestOptions.type) {
        options.type = requestOptions.type;
      }
      if (requestOptions.username) {
        options.username = requestOptions.username;
      }
      if (requestOptions.xhr) {
        options.xhr = requestOptions.xhr;
      }
      if (awa.cv.isValid(requestOptions.cV)) {
        cachedCv = requestOptions.cV;
      } else {
        // CV is automatically incremented before the call is made
        cachedCv = awa.cv.increment();
      }
      var sendApiComplete = function (jqXhr, isSuccess, timeTaken) {
        /// <summary> This method collects data regarding the service call and
        /// fires an OSR event </summary>
        /// ************* PLEASE READ BEFORE MODIFYING *********************
        /// <remarks> This is duplicate code that also exists in vortexEvents. Be mindful when editing the code below.
        /// The method here uses objects that are in the service module, whereas the method in vortexEvents uses
        /// a single JSON object as an input parameter.
        /// These methods could be merged, but the expectation is to separate
        /// the service.js into its own file downloadable from CDN. </remarks>
        /// <param type="Object"> jqXhr object </param>
        /// <param type="Bool"> success of the service call </param>
        /// <param type="Bool"> the time it took for the service call </param>
        var contentLength = jqXhr.getResponseHeader("Content-Length");
        var event = {
          name: "Ms.Webi.OutgoingRequest",
          cV: cachedCv,
          data: {
            baseData: {
              operationName: requestOptions.currentOperationName || awa.ct.getUri(document.location),
              targetUri: targetUriOverrideCallbackFunction
                ? targetUriOverrideCallbackFunction(options.url)
                : options.url,
              latencyMs: timeTaken,
              serviceErrorCode:
                !isSuccess && jqXhr.responseJSON && jqXhr.responseJSON.code && !isNaN(jqXhr.responseJSON.code)
                  ? jqXhr.responseJSON.code
                  : -1,
              succeeded: isSuccess,
              requestMethod: options.type,
              responseContentType: options.dataType,
              protocolStatusCode: jqXhr.status.toString(),
              dependencyOperationName: operationName,
              dependencyOperationVersion: requestOptions.version && requestOptions.version.toString(),
              dependencyName: requestOptions.serviceName,
              dependencyType: "WebService",
              responseSizeBytes: contentLength && parseInt(contentLength, 10)
            },
            baseType: "Ms.Qos.OutgoingServiceRequest",
            impressionGuid: ids.getImpressionGuid(),
            message: isSuccess ? undefined : awa.utils.stringifyField("errorMessage", jqXhr.errorThrown),
            retryCount: retryCount,
            customData:
              requestOptions.customDataCallBack && typeof requestOptions.customDataCallBack === "function"
                ? JSON.stringify(requestOptions.customDataCallBack(jqXhr))
                : undefined
          }
        };
        if (requestOptions.QosCallback && typeof requestOptions.QosCallback === "function") {
          requestOptions.QosCallback(jqXhr, event);
        }
        awa.ct.captureQos(event);
      };
      var callWithRetry = function () {
        /// <summary> this function takes the request options from makeRequest and
        /// recursively makes the required service call </summary>
        /// <returns> jquery XHR object </returns>
        var apiName = operationName + "_Retry_" + retryCount;
        timespanHandler.recordTimeSpan(apiName);
        return $.ajax(options).then(
          function (data, textStatus, jqXhr) {
            var timeTaken = timespanHandler.recordTimeSpan(apiName, true);
            sendApiComplete(jqXhr, true, timeTaken);
            return jqXhr;
          },
          function (jqXhr, status) {
            var timeTaken = timespanHandler.recordTimeSpan(apiName, true);
            sendApiComplete(jqXhr, false, timeTaken);
            var defer = $.Deferred();
            if (maxRetry > retryCount && (jqXhr.status === 0 || (jqXhr.status >= 500 && jqXhr.status < 600))) {
              retryCount++;
              if (awa.cv.isValid(requestOptions.cV)) {
                cachedCv = awa.cv.incrementExternal(cachedCv);
              } else {
                // CV is automatically incremented before the call is made
                cachedCv = awa.cv.increment();
              }
              setTimeout(function () {
                callWithRetry().done(defer.resolve).fail(defer.reject);
              }, 50); // wait 50 ms before retry
            } else {
              defer.reject(jqXhr, status);
            }
            return defer.promise();
          }
        );
      };
      return callWithRetry().then(
        function (data, textStatus, jqXhr) {
          return jqXhr;
        },
        function (jqXhr) {
          return errorFormatter(jqXhr, requestOptions);
        }
      );
    } else {
      awa.logger.logError("jQuery is not defined, cannot use service module");
    }
  };
  function setTargetUriCallbackFunctionOrString(targetUriOverrideStringOrCallback) {
    if (typeof targetUriOverrideStringOrCallback === "function") {
      targetUriOverrideCallbackFunction = targetUriOverrideStringOrCallback;
    } else if (typeof targetUriOverrideStringOrCallback === "string") {
      targetUriOverrideCallbackFunction = function () {
        return targetUriOverrideStringOrCallback;
      };
    }
  }
  return {
    post: function (requestOptions) {
      return makeRequest(awa.utils.extend({}, requestOptions, { method: "POST" }));
    },
    get: function (requestOptions) {
      return makeRequest(awa.utils.extend({ maxRetry: 1 }, requestOptions, { method: "GET" }));
    },
    put: function (requestOptions) {
      return makeRequest(awa.utils.extend({}, requestOptions, { method: "PUT" }));
    },
    del: function (requestOptions) {
      return makeRequest(awa.utils.extend({}, requestOptions, { method: "DELETE" }));
    },
    patch: function (requestOptions) {
      return makeRequest(awa.utils.extend({}, requestOptions, { method: "PATCH" }));
    },
    doNotChangeSupportCors: function () {
      willChangeSupportCors = false;
    },
    alwaysAddCvToRequestHeader: function () {
      alwaysAddCvToRequestHeader = true;
    },
    setTargetUriOverride: setTargetUriCallbackFunctionOrString
  };
})();
